var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoginCover(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M409,242.28c-88.41-51-231.28-51-319.12,0S2.55,376.09,91,427.13s231.28,51.05,319.12,0S497.45,293.33,409,242.28Z",
    style: {
      fill: "#f0f0f0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M125,371.71l79.48-45.9,63.44,36.53a41.61,41.61,0,0,1,11.31-9.21c22.63-13.07,59.19-13.07,81.68,0s22.36,34.24-.27,47.31a68.2,68.2,0,0,1-15.48,6.39l6.38,3.67a2.89,2.89,0,0,1,0,5l-73.72,42.58a11.51,11.51,0,0,1-11.52,0L125,376.71A2.89,2.89,0,0,1,125,371.71Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.73,350.11c-6.54-3.77-17.1-3.77-23.6,0s-6.46,9.9.08,13.68,17.1,3.77,23.6,0S455.27,353.89,448.73,350.11Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.27,367.94,48.86,370a6.29,6.29,0,0,0,6.28,0L274.68,243.26a1.54,1.54,0,0,0,0-2.67l-3.55-2.05a6.27,6.27,0,0,0-6.27,0L45.27,365.26A1.55,1.55,0,0,0,45.27,367.94Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Window--inject-11"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "393.94 78.77 393.71 167.21 398.21 169.81 398.44 81.36 393.94 78.77",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "398.44 81.36 398.44 81.36 398.21 169.81 402.12 167.53 402.33 83.61 398.44 81.36",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.19,
    y: 77.47,
    height: 5.19,
    transform: "translate(128.76 383.15) rotate(-60)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "398.43 84.99 398.44 81.36 393.94 78.77 393.93 82.4 398.43 84.99 398.43 84.99",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "398.43 84.99 401.58 83.18 398.44 81.36 398.44 81.36 398.43 84.99",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.19,
    y: 77.47,
    height: 5.19,
    transform: "translate(128.76 383.15) rotate(-60)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "339.86 47.54 343.76 45.27 343.53 133.71 339.63 135.98 339.86 47.54",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "339.63 135.98 343.53 133.71 456.21 198.76 452.3 201.03 339.63 135.98",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.38,39.78,457,110l-.26,98.77L335.12,138.55ZM452.3,201l.23-88.44L339.86,47.54,339.63,136,452.3,201",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "335.38 39.78 339.28 37.51 460.95 107.75 457.04 110.02 335.38 39.78",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "457.04 110.02 460.95 107.75 460.69 206.52 456.78 208.79 457.04 110.02",
    style: {
      fill: "#f0f0f0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Furniture--inject-11"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "285.11 190.82 285.11 265.51 412.15 338.47 412.15 263.78 285.11 190.82",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "462.26 234.94 462.26 309.63 412.15 338.47 412.15 263.78 462.26 234.94",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "285.11 190.82 285.11 265.51 412.15 338.47 412.15 263.78 285.11 190.82",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "462.26 234.94 462.26 309.63 412.15 338.47 412.15 263.78 462.26 234.94",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "283.31 183.86 413.31 258.53 464.06 229.32 333.99 154.6 283.31 183.86",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "283.31 183.86 283.31 191.49 413.31 266.16 413.31 258.53 283.31 183.86",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "464.06 229.32 464.06 236.95 413.31 266.16 413.31 258.53 464.06 229.32",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "464.06 229.32 464.06 236.95 413.31 266.16 413.31 258.53 464.06 229.32",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "414.46 239.24 442.89 222.67 415.68 206.86 387.25 223.43 414.46 239.24",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "421 232.97 441.24 221.28 437.48 219.1 420.99 228.63 421 232.97",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "441.24 221.28 421 232.97 420.99 228.63 437.48 219.1 441.22 216.94 441.22 216.23 420.37 228.27 420.38 234.03 441.24 221.99 441.24 221.28",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "441.24 221.28 421 232.97 420.99 228.63 437.48 219.1 441.22 216.94 441.22 216.23 420.37 228.27 420.38 234.03 441.24 221.99 441.24 221.28",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "441.24 221.28 421 232.97 420.99 228.63 437.48 219.1 441.22 216.94 441.22 216.23 420.37 228.27 420.38 234.03 441.24 221.99 441.24 221.28",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "420.37 228.27 390.33 210.82 390.34 216.58 420.38 234.03 420.37 228.27",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "420.37 228.27 390.33 210.82 390.34 216.58 420.38 234.03 420.37 228.27",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "420.37 228.27 390.33 210.82 390.34 216.58 420.38 234.03 420.37 228.27",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "420.37 228.27 441.22 216.23 411.18 198.78 390.33 210.82 420.37 228.27",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "420.37 228.27 441.22 216.23 411.18 198.78 390.33 210.82 420.37 228.27",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "440.66 217.26 440.66 221.62 421 232.97 420.99 228.63 440.66 217.26",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "440.66 217.26 440.66 221.62 421 232.97 420.99 228.63 440.66 217.26",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.66,234.25l.44-1.57,1.5.45c-1.67-1.61-.48-3.63-2.43-4.72l-1.93,1.12C424.05,230.86,423,232.38,424.66,234.25Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M424.66,234.25l.44-1.57,1.5.45c-1.67-1.61-.48-3.63-2.43-4.72l-1.93,1.12C424.05,230.86,423,232.38,424.66,234.25Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M410.52,202.83l-13.07,7.54a.53.53,0,0,0,0,.92l7.1,4.13a1.37,1.37,0,0,0,1.33,0L419,207.87a.53.53,0,0,0,0-.91l-7.11-4.13A1.3,1.3,0,0,0,410.52,202.83Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "421.38 208.26 406.86 216.65 408 217.31 422.52 208.93 421.38 208.26",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "408.55 217.76 409.69 218.43 417.39 213.98 416.25 213.32 408.55 217.76",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "394.79 212.78 394.79 212.78 394.26 212.47 394.26 212.48 388.87 209.37 388.87 209.37 388.34 209.06 408.01 197.71 433.29 212.29 413.63 223.65 394.79 212.78",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.34,209.07h0l.53.3h0l5.39,3.11h0l.53.3h0l18.84,10.87a.56.56,0,0,0-.27.45l0,6.82a.16.16,0,0,0,.08.16h0l-25.28-14.58h0a.17.17,0,0,1-.07-.16l0-6.82A.57.57,0,0,1,388.34,209.07Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.36,224.1a.56.56,0,0,1,.27-.45l19.66-11.36v.61L413.9,224.1v6.21l19.4-11.2v.61l-19.66,11.35a.19.19,0,0,1-.19,0,.16.16,0,0,1-.08-.16Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "394.79 212.78 394.79 212.78 394.26 212.47 394.26 212.48 388.87 209.37 388.87 209.37 388.34 209.06 408.01 197.71 433.29 212.29 413.63 223.65 394.79 212.78",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.34,209.07h0l.53.3h0l5.39,3.11h0l.53.3h0l18.84,10.87a.56.56,0,0,0-.27.45l0,6.82a.16.16,0,0,0,.08.16h0l-25.28-14.58h0a.17.17,0,0,1-.07-.16l0-6.82A.57.57,0,0,1,388.34,209.07Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.36,224.1a.56.56,0,0,1,.27-.45l19.66-11.36v.61L413.9,224.1v6.21l19.4-11.2v.61l-19.66,11.35a.19.19,0,0,1-.19,0,.16.16,0,0,1-.08-.16Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "432.08 213.6 432.08 218.65 413.91 229.21 413.89 224.1 432.08 213.6",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "432.08 213.6 432.08 218.65 413.91 229.21 413.89 224.1 432.08 213.6",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "433.31 219.11 432.08 218.38 432.08 218.65 413.91 229.21 413.91 230.31 433.31 219.11",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "433.31 219.11 432.08 218.38 432.08 218.65 413.91 229.21 413.91 230.31 433.31 219.11",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.34,209.07h0L408,197.71l25.28,14.58v.61L413.9,224.1v5.1l18.17-10.55v-.27l1.23.73v.61l-19.66,11.35a.19.19,0,0,1-.19,0h0l-25.28-14.58h0a.17.17,0,0,1-.07-.16l0-6.82A.57.57,0,0,1,388.34,209.07Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.3,229l.44-1.57,1.5.45c-1.66-1.61-.48-3.63-2.42-4.72l-1.94,1.12C416.69,225.56,415.67,227.07,417.3,229Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M417.3,229l.44-1.57,1.5.45c-1.66-1.61-.48-3.63-2.42-4.72l-1.94,1.12C416.69,225.56,415.67,227.07,417.3,229Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "419.6 221.51 437.93 210.93 434.53 208.95 419.59 217.58 419.6 221.51",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "437.93 210.93 419.6 221.51 419.59 217.58 434.53 208.95 437.92 206.99 437.92 206.35 419.03 217.26 419.05 222.47 437.94 211.57 437.93 210.93",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "437.93 210.93 419.6 221.51 419.59 217.58 434.53 208.95 437.92 206.99 437.92 206.35 419.03 217.26 419.05 222.47 437.94 211.57 437.93 210.93",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "437.93 210.93 419.6 221.51 419.59 217.58 434.53 208.95 437.92 206.99 437.92 206.35 419.03 217.26 419.05 222.47 437.94 211.57 437.93 210.93",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "419.03 217.26 391.82 201.45 391.84 206.66 419.05 222.47 419.03 217.26",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "419.03 217.26 391.82 201.45 391.84 206.66 419.05 222.47 419.03 217.26",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "419.03 217.26 391.82 201.45 391.84 206.66 419.05 222.47 419.03 217.26",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "419.03 217.26 437.92 206.35 410.71 190.54 391.82 201.45 419.03 217.26",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "419.03 217.26 437.92 206.35 410.71 190.54 391.82 201.45 419.03 217.26",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "437.41 207.29 437.41 211.23 419.6 221.51 419.59 217.58 437.41 207.29",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "437.41 207.29 437.41 211.23 419.6 221.51 419.59 217.58 437.41 207.29",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.11,194.21,398.27,201a.48.48,0,0,0,0,.83l6.44,3.74a1.17,1.17,0,0,0,1.2,0l11.83-6.83a.48.48,0,0,0,0-.83l-6.44-3.74A1.2,1.2,0,0,0,410.11,194.21Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "419.95 199.14 406.8 206.73 407.83 207.33 420.99 199.74 419.95 199.14",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "408.32 207.74 409.36 208.34 416.33 204.31 415.3 203.71 408.32 207.74",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.24,222v-.71l-.58-.33v-3.69l-3.18,1.84h0l3.74-2.16v-.71l-5.66-3.29,2.37-1.37v-.64l-.52-.3v-3.34l-1.41.81,1.92-1.11v-.64l-27.21-15.81-18.89,10.91,0,5.21.33.2-3.83,2.21h0a.57.57,0,0,0-.26.45l0,6.82a.17.17,0,0,0,.07.16h0l25.28,14.58h0a.19.19,0,0,0,.19,0l.82-.47,5.91,3.43,3.25-1.87a4.51,4.51,0,0,0,1,2.09l.44-1.57,1.5.45a3.6,3.6,0,0,1-1-2.1Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M452.8,328.39l-15.83.46-15.83-.46c-.69,10.69,1.4,21.59,4.28,26.91h0a7.23,7.23,0,0,0,3.14,3.19c4.67,2.7,12.22,2.7,16.86,0a7,7,0,0,0,3.13-3.27C451.42,349.87,453.48,339,452.8,328.39Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.13,321.9c6.2,3.59,6.23,9.39.07,13s-16.19,3.59-22.39,0-6.24-9.38-.07-13S441.93,318.32,448.13,321.9Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.68,323.33c4.84,2.79,4.86,7.32.05,10.12s-12.63,2.79-17.47,0-4.86-7.33-.05-10.12S440.84,320.54,445.68,323.33Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.15
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M445.68,323.33c4.84,2.79,4.86,7.32.05,10.12s-12.63,2.79-17.47,0-4.86-7.33-.05-10.12S440.84,320.54,445.68,323.33Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M463,260.83c-35.68,11.68-36,35.55-28,52.55,2,3.44,8.17,5.29,13.51-15.85l-9.37,1.2,10.92-5.54,2.84-8.48-9.11.68,11.56-4.86A171.38,171.38,0,0,1,463,260.83Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463,260.83c-35.68,11.68-36,35.55-28,52.55,2,3.44,8.17,5.29,13.51-15.85l-9.37,1.2,10.92-5.54,2.84-8.48-9.11.68,11.56-4.86A171.38,171.38,0,0,1,463,260.83Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463,260.83c-35.68,11.68-36,35.55-28,52.55,2,3.44,8.17,5.29,13.51-15.85l-9.37,1.2,10.92-5.54,2.84-8.48-9.11.68,11.56-4.86A171.38,171.38,0,0,1,463,260.83Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.91,266.8c-18.82,14.28-20.52,30.65-15.2,47.74C435.83,299.49,433.8,284.27,452.91,266.8Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.57,285.07c35.17,5,39.44,27.13,34.77,44.3-1.32,3.54-6.73,6.28-15.22-12.52l8.93-.44L420,313.07l-4-7.42,8.59-.89-11.57-2.6A163.18,163.18,0,0,0,402.57,285.07Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.57,285.07c35.17,5,39.44,27.13,34.77,44.3-1.32,3.54-6.73,6.28-15.22-12.52l8.93-.44L420,313.07l-4-7.42,8.59-.89-11.57-2.6A163.18,163.18,0,0,0,402.57,285.07Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.57,285.07c35.17,5,39.44,27.13,34.77,44.3-1.32,3.54-6.73,6.28-15.22-12.52l8.93-.44L420,313.07l-4-7.42,8.59-.89-11.57-2.6A163.18,163.18,0,0,0,402.57,285.07Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413,289c19.89,10.17,24.2,25.14,22.09,41.94C434.3,316.57,433.66,302.06,413,289Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.3,293.38c-32.26.53-38.59,20-36.3,36,.79,3.34,5.36,6.41,15.11-9.58l-8-1.4,10.37-1.77,4.48-6.24-7.65-1.75,10.73-1.06A146,146,0,0,1,473.3,293.38Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.5,295.72c-19.08,6.94-24.63,19.95-24.61,35.33C441.17,318.22,443.37,305.21,463.5,295.72Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.3,293.38c-32.26.53-38.59,20-36.3,36,.79,3.34,5.36,6.41,15.11-9.58l-8-1.4,10.37-1.77,4.48-6.24-7.65-1.75,10.73-1.06A146,146,0,0,1,473.3,293.38Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-11"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "49.42 202.33 49.38 190 42.95 186.34 42.98 198.38 42.98 198.38 42.99 198.66 49.42 202.33 49.42 202.33",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.82,345.09l-.4-142.76L43,198.66l.4,142.48a2.69,2.69,0,0,0,1.08,2.42h0l0,0,0,0,6.34,3.87A2.68,2.68,0,0,1,49.82,345.09Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.82,345.09l-.4-142.76L43,198.66l.4,142.48a2.69,2.69,0,0,0,1.08,2.42h0l0,0,0,0,6.34,3.87A2.68,2.68,0,0,1,49.82,345.09Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.64,347.26a4.48,4.48,0,0,1-.74.35A4.48,4.48,0,0,0,53.64,347.26Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.38,347.73l-.16,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.06,347.59h0l-.05,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.4,190l0-7.1a8.37,8.37,0,0,1,3.8-6.58L268.29,52.1a2.7,2.7,0,0,1,2.67-.28l-6.35-3.9h0a2.65,2.65,0,0,0-2.75.22L46.75,172.35a8.38,8.38,0,0,0-3.8,6.58l0,7.1h0l0,0v.28L49.38,190Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.4,190l0-7.1a8.37,8.37,0,0,1,3.8-6.58L268.29,52.1a2.7,2.7,0,0,1,2.67-.28l-6.35-3.9h0a2.65,2.65,0,0,0-2.75.22L46.75,172.35a8.38,8.38,0,0,0-3.8,6.58l0,7.1h0l0,0v.28L49.38,190Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "49.42 202.33 49.38 190 42.95 186.34 42.98 198.38 42.98 198.38 42.99 198.66 49.42 202.33 49.42 202.33",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "49.42 202.33 49.38 190 42.95 186.34 42.98 198.38 42.98 198.38 42.99 198.66 49.42 202.33 49.42 202.33",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.29,52.1c2.1-1.21,3.82-.24,3.82,2.18l0,7.11L49.4,190l0-7.1a8.37,8.37,0,0,1,3.8-6.58Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.87,63.85c1.13-.65,2-.13,2,1.16a4.51,4.51,0,0,1-2,3.52c-1.13.65-2,.13-2-1.17A4.49,4.49,0,0,1,253.87,63.85Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.09,60.26c1.12-.65,2-.13,2,1.16a4.44,4.44,0,0,1-2,3.52c-1.12.65-2,.13-2-1.16A4.44,4.44,0,0,1,260.09,60.26Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.3,56.67c1.12-.64,2-.12,2,1.17a4.51,4.51,0,0,1-2,3.52c-1.13.65-2,.12-2-1.17A4.46,4.46,0,0,1,266.3,56.67Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.2,157.08c.84-.49,1.61-.41,2,.21l2,3.12c.4.62,1.17.71,2,.22L272.11,61.41l0,12.34L49.42,202.34l0-12.34,6.6-3.81a5.07,5.07,0,0,0,2-2.55l2-5.43a5,5,0,0,1,2-2.54Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.15,73.73l.4,142.76a8.38,8.38,0,0,1-3.79,6.58L53.64,347.26c-2.11,1.22-3.81.24-3.82-2.17l-.4-142.76Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M272.15,73.73l.4,142.76a8.38,8.38,0,0,1-3.79,6.58L53.64,347.26c-2.11,1.22-3.81.24-3.82-2.17l-.4-142.76Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M263.34,69c1.49-.86,2.7-.17,2.71,1.55a6,6,0,0,1-2.7,4.67L74.82,184.06c-1.5.86-2.72.17-2.72-1.55a5.92,5.92,0,0,1,2.7-4.67Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53,191.1a.26.26,0,0,1,.28,0c.14.1.13.38,0,.63l-1.19,1.94,3.12-1.8a.24.24,0,0,1,.39.21.87.87,0,0,1-.39.67l-3.12,1.8,1.2.56c.15.08.16.35,0,.61a.82.82,0,0,1-.28.3.28.28,0,0,1-.26,0l-1.91-.92-.08-.07v0l0-.16,0-.19v0l.07-.16,1.91-3.12A.62.62,0,0,1,53,191.1Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.73,187.2a.28.28,0,0,1,.26,0l1.92.91.07.09h0l0,.16,0,.19,0,0-.07.15L60,191.84a.92.92,0,0,1-.26.26.26.26,0,0,1-.28,0c-.14-.09-.14-.37,0-.63l1.18-1.94-3.12,1.8a.23.23,0,0,1-.38-.22.83.83,0,0,1,.38-.65l3.12-1.8-1.19-.57c-.16-.08-.17-.35,0-.61A.73.73,0,0,1,59.73,187.2Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.15,183.49a1.71,1.71,0,0,1,1.29-.24l.28-.37a.72.72,0,0,1,.21-.19.28.28,0,0,1,.21-.05c.13,0,.19.15.17.34l-.16,1.17a.88.88,0,0,1-.37.59l-.1,0-.93.26a.22.22,0,0,1-.28-.19.74.74,0,0,1,.17-.54l.09-.12a1.15,1.15,0,0,0-.58.18,3,3,0,0,0-1.37,2.37c0,.87.62,1.22,1.38.78a3,3,0,0,0,1.2-1.51.89.89,0,0,1,.33-.42.45.45,0,0,1,.19-.05c.18,0,.25.24.15.51a4.7,4.7,0,0,1-1.87,2.35c-1.17.67-2.14.13-2.14-1.22A4.71,4.71,0,0,1,66.15,183.49Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53,191.1a.26.26,0,0,1,.28,0c.14.1.13.38,0,.63l-1.19,1.94,3.12-1.8a.24.24,0,0,1,.39.21.87.87,0,0,1-.39.67l-3.12,1.8,1.2.56c.15.08.16.35,0,.61a.82.82,0,0,1-.28.3.28.28,0,0,1-.26,0l-1.91-.92-.08-.07v0l0-.16,0-.19v0l.07-.16,1.91-3.12A.62.62,0,0,1,53,191.1Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M59.73,187.2a.28.28,0,0,1,.26,0l1.92.91.07.09h0l0,.16,0,.19,0,0-.07.15L60,191.84a.92.92,0,0,1-.26.26.26.26,0,0,1-.28,0c-.14-.09-.14-.37,0-.63l1.18-1.94-3.12,1.8a.23.23,0,0,1-.38-.22.83.83,0,0,1,.38-.65l3.12-1.8-1.19-.57c-.16-.08-.17-.35,0-.61A.73.73,0,0,1,59.73,187.2Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M66.15,183.49a1.71,1.71,0,0,1,1.29-.24l.28-.37a.72.72,0,0,1,.21-.19.28.28,0,0,1,.21-.05c.13,0,.19.15.17.34l-.16,1.17a.88.88,0,0,1-.37.59l-.1,0-.93.26a.22.22,0,0,1-.28-.19.74.74,0,0,1,.17-.54l.09-.12a1.15,1.15,0,0,0-.58.18,3,3,0,0,0-1.37,2.37c0,.87.62,1.22,1.38.78a3,3,0,0,0,1.2-1.51.89.89,0,0,1,.33-.42.45.45,0,0,1,.19-.05c.18,0,.25.24.15.51a4.7,4.7,0,0,1-1.87,2.35c-1.17.67-2.14.13-2.14-1.22A4.71,4.71,0,0,1,66.15,183.49Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M272.15,73.75h0l0-12.34L100.25,160.63l-.06,0L272.13,61.39l0-7.11A2.62,2.62,0,0,0,271,51.82h0l-6.35-3.9h0a2.65,2.65,0,0,0-2.75.22L46.75,172.35a8.38,8.38,0,0,0-3.8,6.58l0,7.1h0l0,0v.28l0,12v.28l.4,142.48a2.69,2.69,0,0,0,1.08,2.42h0l0,0,0,0,6.34,3.87.15.09.05,0h0a2.74,2.74,0,0,0,2.58-.32L268.76,223.07a8.38,8.38,0,0,0,3.79-6.58Zm-222,272.81s0-.09,0-.14S50.09,346.52,50.11,346.56Zm-.21-.66a4.12,4.12,0,0,1-.08-.81A4.12,4.12,0,0,0,49.9,345.9ZM269.76,51.59l-.13,0Zm-.71.16a4.23,4.23,0,0,0-.76.35A4.23,4.23,0,0,1,269.05,51.75ZM50,180.05a7.22,7.22,0,0,0-.65,2.83h0A7.22,7.22,0,0,1,50,180.05ZM49.4,190h0L56,186.15l-.06,0L49.38,190Zm0,12.35Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "222.98 218.01 222.04 220.18 214.3 224.66 214.33 236.09 228.78 227.74 228.75 216.9 228.74 216.31 228.74 214.69 222.98 218.01",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "228.78 231.02 214.33 239.37 214.33 238.08 228.78 229.74 228.78 231.02",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "228.78 232.42 228.78 233.7 221.12 238.12 221.12 236.84 228.78 232.42",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "228.78 231.02 214.33 239.37 214.33 238.08 228.78 229.74 228.78 231.02",
    style: {
      fill: "#407BFF",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "228.78 232.42 228.78 233.7 221.12 238.12 221.12 236.84 228.78 232.42",
    style: {
      fill: "#407BFF",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "222.98 184.69 222.04 186.87 214.3 191.34 214.33 202.77 228.78 194.43 228.75 183.58 228.74 183 228.74 181.37 222.98 184.69",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "228.78 197.71 214.33 206.05 214.33 204.77 228.78 196.43 228.78 197.71",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "228.78 199.1 228.78 200.39 221.12 204.81 221.12 203.52 228.78 199.1",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "228.78 197.71 214.33 206.05 214.33 204.77 228.78 196.43 228.78 197.71",
    style: {
      fill: "#407BFF",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "228.78 199.1 228.78 200.39 221.12 204.81 221.12 203.52 228.78 199.1",
    style: {
      fill: "#407BFF",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "222.98 151.38 222.04 153.55 214.3 158.03 214.33 169.46 228.78 161.12 228.75 150.27 228.74 149.69 228.74 148.06 222.98 151.38",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "228.78 164.4 214.33 172.74 214.33 171.45 228.78 163.11 228.78 164.4",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "228.78 165.79 228.78 167.07 221.12 171.49 221.12 170.21 228.78 165.79",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "228.78 164.4 214.33 172.74 214.33 171.45 228.78 163.11 228.78 164.4",
    style: {
      fill: "#407BFF",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "228.78 165.79 228.78 167.07 221.12 171.49 221.12 170.21 228.78 165.79",
    style: {
      fill: "#407BFF",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "222.98 118.07 222.04 120.24 214.3 124.71 214.33 136.14 228.78 127.8 228.75 116.95 228.74 116.37 228.74 114.74 222.98 118.07",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "228.78 131.08 214.33 139.42 214.33 138.14 228.78 129.8 228.78 131.08",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "228.78 132.47 228.78 133.76 221.12 138.18 221.12 136.9 228.78 132.47",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "228.78 131.08 214.33 139.42 214.33 138.14 228.78 129.8 228.78 131.08",
    style: {
      fill: "#407BFF",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "228.78 132.47 228.78 133.76 221.12 138.18 221.12 136.9 228.78 132.47",
    style: {
      fill: "#407BFF",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "251.25 201.63 250.31 203.81 242.56 208.28 242.59 219.71 257.04 211.37 257.01 200.52 257.01 199.94 257 198.31 251.25 201.63",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "257.04 214.65 242.59 222.99 242.59 221.71 257.04 213.37 257.04 214.65",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "257.04 216.04 257.04 217.32 249.38 221.75 249.38 220.46 257.04 216.04",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "257.04 214.65 242.59 222.99 242.59 221.71 257.04 213.37 257.04 214.65",
    style: {
      fill: "#407BFF",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "257.04 216.04 257.04 217.32 249.38 221.75 249.38 220.46 257.04 216.04",
    style: {
      fill: "#407BFF",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "251.25 168.32 250.31 170.49 242.56 174.97 242.59 186.4 257.04 178.05 257.01 167.21 257.01 166.63 257 165 251.25 168.32",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "257.04 181.34 242.59 189.68 242.59 188.39 257.04 180.05 257.04 181.34",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "257.04 182.73 257.04 184.01 249.38 188.43 249.38 187.15 257.04 182.73",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "257.04 181.34 242.59 189.68 242.59 188.39 257.04 180.05 257.04 181.34",
    style: {
      fill: "#407BFF",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "257.04 182.73 257.04 184.01 249.38 188.43 249.38 187.15 257.04 182.73",
    style: {
      fill: "#407BFF",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "251.25 135.01 250.31 137.18 242.56 141.65 242.59 153.08 257.04 144.74 257.01 133.89 257.01 133.31 257 131.68 251.25 135.01",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "257.04 148.02 242.59 156.36 242.59 155.08 257.04 146.74 257.04 148.02",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "257.04 149.41 257.04 150.7 249.38 155.12 249.38 153.84 257.04 149.41",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "257.04 148.02 242.59 156.36 242.59 155.08 257.04 146.74 257.04 148.02",
    style: {
      fill: "#407BFF",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "257.04 149.41 257.04 150.7 249.38 155.12 249.38 153.84 257.04 149.41",
    style: {
      fill: "#407BFF",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "251.25 101.69 250.31 103.86 242.56 108.34 242.59 119.77 257.04 111.43 257.01 100.58 257.01 100 257 98.37 251.25 101.69",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "257.04 114.71 242.59 123.05 242.59 121.77 257.04 113.42 257.04 114.71",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "257.04 116.1 257.04 117.38 249.38 121.8 249.38 120.52 257.04 116.1",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "257.04 114.71 242.59 123.05 242.59 121.77 257.04 113.42 257.04 114.71",
    style: {
      fill: "#407BFF",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "257.04 116.1 257.04 117.38 249.38 121.8 249.38 120.52 257.04 116.1",
    style: {
      fill: "#407BFF",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "194.08 234.77 193.15 236.94 185.4 241.41 185.43 252.84 199.88 244.5 199.85 233.65 199.84 233.07 199.84 231.44 194.08 234.77",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "199.88 247.78 185.43 256.12 185.43 254.84 199.88 246.5 199.88 247.78",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "199.88 249.17 199.88 250.46 192.22 254.88 192.22 253.59 199.88 249.17",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "199.88 247.78 185.43 256.12 185.43 254.84 199.88 246.5 199.88 247.78",
    style: {
      fill: "#407BFF",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "199.88 249.17 199.88 250.46 192.22 254.88 192.22 253.59 199.88 249.17",
    style: {
      fill: "#407BFF",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "194.08 201.45 193.15 203.63 185.4 208.1 185.43 219.53 199.88 211.19 199.85 200.34 199.84 199.76 199.84 198.13 194.08 201.45",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "199.88 214.47 185.43 222.81 185.43 221.53 199.88 213.18 199.88 214.47",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "199.88 215.86 199.88 217.14 192.22 221.56 192.22 220.28 199.88 215.86",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "199.88 214.47 185.43 222.81 185.43 221.53 199.88 213.18 199.88 214.47",
    style: {
      fill: "#407BFF",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "199.88 215.86 199.88 217.14 192.22 221.56 192.22 220.28 199.88 215.86",
    style: {
      fill: "#407BFF",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "194.08 168.14 193.15 170.31 185.4 174.78 185.43 186.21 199.88 177.87 199.85 167.03 199.84 166.44 199.84 164.81 194.08 168.14",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "199.88 181.15 185.43 189.5 185.43 188.21 199.88 179.87 199.88 181.15",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "199.88 182.55 199.88 183.83 192.22 188.25 192.22 186.97 199.88 182.55",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "199.88 181.15 185.43 189.5 185.43 188.21 199.88 179.87 199.88 181.15",
    style: {
      fill: "#407BFF",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "199.88 182.55 199.88 183.83 192.22 188.25 192.22 186.97 199.88 182.55",
    style: {
      fill: "#407BFF",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "194.08 134.82 193.15 137 185.4 141.47 185.43 152.9 199.88 144.56 199.85 133.71 199.84 133.13 199.84 131.5 194.08 134.82",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "199.88 147.84 185.43 156.18 185.43 154.9 199.88 146.56 199.88 147.84",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "199.88 149.23 199.88 150.51 192.22 154.94 192.22 153.65 199.88 149.23",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "199.88 147.84 185.43 156.18 185.43 154.9 199.88 146.56 199.88 147.84",
    style: {
      fill: "#407BFF",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "199.88 149.23 199.88 150.51 192.22 154.94 192.22 153.65 199.88 149.23",
    style: {
      fill: "#407BFF",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "165.19 251.52 164.25 253.7 156.5 258.17 156.53 269.6 170.98 261.26 170.95 250.41 170.95 249.83 170.94 248.2 165.19 251.52",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "170.98 264.54 156.53 272.88 156.53 271.6 170.98 263.25 170.98 264.54",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "170.98 265.93 170.98 267.21 163.32 271.63 163.32 270.35 170.98 265.93",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "170.98 264.54 156.53 272.88 156.53 271.6 170.98 263.25 170.98 264.54",
    style: {
      fill: "#407BFF",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "170.98 265.93 170.98 267.21 163.32 271.63 163.32 270.35 170.98 265.93",
    style: {
      fill: "#407BFF",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "165.19 218.21 164.25 220.38 156.5 224.86 156.53 236.28 170.98 227.94 170.95 217.1 170.95 216.51 170.94 214.89 165.19 218.21",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "170.98 231.22 156.53 239.57 156.53 238.28 170.98 229.94 170.98 231.22",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "170.98 232.62 170.98 233.9 163.32 238.32 163.32 237.04 170.98 232.62",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "170.98 231.22 156.53 239.57 156.53 238.28 170.98 229.94 170.98 231.22",
    style: {
      fill: "#407BFF",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "170.98 232.62 170.98 233.9 163.32 238.32 163.32 237.04 170.98 232.62",
    style: {
      fill: "#407BFF",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "165.19 184.9 164.25 187.07 156.5 191.54 156.53 202.97 170.98 194.63 170.95 183.78 170.95 183.2 170.94 181.57 165.19 184.9",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "170.98 197.91 156.53 206.25 156.53 204.97 170.98 196.63 170.98 197.91",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "170.98 199.3 170.98 200.59 163.32 205.01 163.32 203.72 170.98 199.3",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "170.98 197.91 156.53 206.25 156.53 204.97 170.98 196.63 170.98 197.91",
    style: {
      fill: "#407BFF",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "170.98 199.3 170.98 200.59 163.32 205.01 163.32 203.72 170.98 199.3",
    style: {
      fill: "#407BFF",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "165.19 151.58 164.25 153.75 156.5 158.23 156.53 169.66 170.98 161.32 170.95 150.47 170.95 149.89 170.94 148.26 165.19 151.58",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "170.98 164.6 156.53 172.94 156.53 171.66 170.98 163.31 170.98 164.6",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "170.98 165.99 170.98 167.27 163.32 171.69 163.32 170.41 170.98 165.99",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "170.98 164.6 156.53 172.94 156.53 171.66 170.98 163.31 170.98 164.6",
    style: {
      fill: "#407BFF",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "170.98 165.99 170.98 167.27 163.32 171.69 163.32 170.41 170.98 165.99",
    style: {
      fill: "#407BFF",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "136.29 268.28 135.35 270.45 127.6 274.93 127.63 286.36 142.08 278.01 142.05 267.17 142.05 266.59 142.04 264.96 136.29 268.28",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "142.08 281.3 127.63 289.64 127.63 288.35 142.08 280.01 142.08 281.3",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "142.08 282.69 142.08 283.97 134.42 288.39 134.42 287.11 142.08 282.69",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "142.08 281.3 127.63 289.64 127.63 288.35 142.08 280.01 142.08 281.3",
    style: {
      fill: "#407BFF",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "142.08 282.69 142.08 283.97 134.42 288.39 134.42 287.11 142.08 282.69",
    style: {
      fill: "#407BFF",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "136.29 234.97 135.35 237.14 127.6 241.61 127.63 253.04 142.08 244.7 142.05 233.85 142.05 233.27 142.04 231.64 136.29 234.97",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "142.08 247.98 127.63 256.32 127.63 255.04 142.08 246.7 142.08 247.98",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "142.08 249.37 142.08 250.66 134.42 255.08 134.42 253.79 142.08 249.37",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "142.08 247.98 127.63 256.32 127.63 255.04 142.08 246.7 142.08 247.98",
    style: {
      fill: "#407BFF",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "142.08 249.37 142.08 250.66 134.42 255.08 134.42 253.79 142.08 249.37",
    style: {
      fill: "#407BFF",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "136.29 201.65 135.35 203.83 127.6 208.3 127.63 219.73 142.08 211.39 142.05 200.54 142.05 199.96 142.04 198.33 136.29 201.65",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "142.08 214.67 127.63 223.01 127.63 221.73 142.08 213.38 142.08 214.67",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "142.08 216.06 142.08 217.34 134.42 221.76 134.42 220.48 142.08 216.06",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "142.08 214.67 127.63 223.01 127.63 221.73 142.08 213.38 142.08 214.67",
    style: {
      fill: "#407BFF",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "142.08 216.06 142.08 217.34 134.42 221.76 134.42 220.48 142.08 216.06",
    style: {
      fill: "#407BFF",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "136.29 168.34 135.35 170.51 127.6 174.99 127.63 186.41 142.08 178.07 142.05 167.23 142.05 166.64 142.04 165.02 136.29 168.34",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "142.08 181.35 127.63 189.7 127.63 188.41 142.08 180.07 142.08 181.35",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "142.08 182.75 142.08 184.03 134.42 188.45 134.42 187.17 142.08 182.75",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "142.08 181.35 127.63 189.7 127.63 188.41 142.08 180.07 142.08 181.35",
    style: {
      fill: "#407BFF",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "142.08 182.75 142.08 184.03 134.42 188.45 134.42 187.17 142.08 182.75",
    style: {
      fill: "#407BFF",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "107.39 285.04 106.45 287.21 98.7 291.69 98.73 303.11 113.18 294.77 113.15 283.93 113.15 283.34 113.14 281.71 107.39 285.04",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "113.18 298.05 98.73 306.39 98.73 305.11 113.18 296.77 113.18 298.05",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "113.18 299.45 113.18 300.73 105.52 305.15 105.52 303.87 113.18 299.45",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "113.18 298.05 98.73 306.39 98.73 305.11 113.18 296.77 113.18 298.05",
    style: {
      fill: "#407BFF",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "113.18 299.45 113.18 300.73 105.52 305.15 105.52 303.87 113.18 299.45",
    style: {
      fill: "#407BFF",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "107.39 251.72 106.45 253.9 98.7 258.37 98.73 269.8 113.18 261.46 113.15 250.61 113.15 250.03 113.14 248.4 107.39 251.72",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "113.18 264.74 98.73 273.08 98.73 271.8 113.18 263.46 113.18 264.74",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "113.18 266.13 113.18 267.42 105.52 271.84 105.52 270.55 113.18 266.13",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "113.18 264.74 98.73 273.08 98.73 271.8 113.18 263.46 113.18 264.74",
    style: {
      fill: "#407BFF",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "113.18 266.13 113.18 267.42 105.52 271.84 105.52 270.55 113.18 266.13",
    style: {
      fill: "#407BFF",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "107.39 218.41 106.45 220.58 98.7 225.06 98.73 236.49 113.18 228.14 113.15 217.3 113.15 216.72 113.14 215.09 107.39 218.41",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "113.18 231.43 98.73 239.77 98.73 238.48 113.18 230.14 113.18 231.43",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "113.18 232.82 113.18 234.1 105.52 238.52 105.52 237.24 113.18 232.82",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "113.18 231.43 98.73 239.77 98.73 238.48 113.18 230.14 113.18 231.43",
    style: {
      fill: "#407BFF",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "113.18 232.82 113.18 234.1 105.52 238.52 105.52 237.24 113.18 232.82",
    style: {
      fill: "#407BFF",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "107.39 185.1 106.45 187.27 98.7 191.74 98.73 203.17 113.18 194.83 113.15 183.98 113.15 183.4 113.14 181.77 107.39 185.1",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "113.18 198.11 98.73 206.45 98.73 205.17 113.18 196.83 113.18 198.11",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "113.18 199.5 113.18 200.79 105.52 205.21 105.52 203.93 113.18 199.5",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "113.18 198.11 98.73 206.45 98.73 205.17 113.18 196.83 113.18 198.11",
    style: {
      fill: "#407BFF",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "113.18 199.5 113.18 200.79 105.52 205.21 105.52 203.93 113.18 199.5",
    style: {
      fill: "#407BFF",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "78.49 301.8 77.55 303.97 69.8 308.44 69.83 319.87 84.28 311.53 84.25 300.68 84.25 300.1 84.25 298.47 78.49 301.8",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "84.28 314.81 69.83 323.15 69.83 321.87 84.28 313.53 84.28 314.81",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "84.28 316.2 84.28 317.49 76.63 321.91 76.63 320.62 84.28 316.2",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "84.28 314.81 69.83 323.15 69.83 321.87 84.28 313.53 84.28 314.81",
    style: {
      fill: "#407BFF",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "84.28 316.2 84.28 317.49 76.63 321.91 76.63 320.62 84.28 316.2",
    style: {
      fill: "#407BFF",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "78.49 268.48 77.55 270.65 69.8 275.13 69.83 286.56 84.28 278.22 84.25 267.37 84.25 266.79 84.25 265.16 78.49 268.48",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "84.28 281.5 69.83 289.84 69.83 288.56 84.28 280.21 84.28 281.5",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "84.28 282.89 84.28 284.17 76.63 288.59 76.63 287.31 84.28 282.89",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "84.28 281.5 69.83 289.84 69.83 288.56 84.28 280.21 84.28 281.5",
    style: {
      fill: "#407BFF",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "84.28 282.89 84.28 284.17 76.63 288.59 76.63 287.31 84.28 282.89",
    style: {
      fill: "#407BFF",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "78.49 235.17 77.55 237.34 69.8 241.81 69.83 253.24 84.28 244.9 84.25 234.06 84.25 233.47 84.25 231.84 78.49 235.17",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "84.28 248.18 69.83 256.52 69.83 255.24 84.28 246.9 84.28 248.18",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "84.28 249.57 84.28 250.86 76.63 255.28 76.63 254 84.28 249.57",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "84.28 248.18 69.83 256.52 69.83 255.24 84.28 246.9 84.28 248.18",
    style: {
      fill: "#407BFF",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "84.28 249.57 84.28 250.86 76.63 255.28 76.63 254 84.28 249.57",
    style: {
      fill: "#407BFF",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "78.49 201.85 77.55 204.03 69.8 208.5 69.83 219.93 84.28 211.59 84.25 200.74 84.25 200.16 84.25 198.53 78.49 201.85",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "84.28 214.87 69.83 223.21 69.83 221.93 84.28 213.59 84.28 214.87",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "84.28 216.26 84.28 217.54 76.63 221.97 76.63 220.68 84.28 216.26",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "84.28 214.87 69.83 223.21 69.83 221.93 84.28 213.59 84.28 214.87",
    style: {
      fill: "#407BFF",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "84.28 216.26 84.28 217.54 76.63 221.97 76.63 220.68 84.28 216.26",
    style: {
      fill: "#407BFF",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "222.98 218.01 222.04 220.18 214.3 224.66 214.33 236.09 228.78 227.74 228.75 216.9 228.74 216.31 228.74 214.69 222.98 218.01",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "228.78 231.02 214.33 239.37 214.33 238.08 228.78 229.74 228.78 231.02",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "228.78 232.42 228.78 233.7 221.12 238.12 221.12 236.84 228.78 232.42",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "228.78 231.02 214.33 239.37 214.33 238.08 228.78 229.74 228.78 231.02",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "228.78 232.42 228.78 233.7 221.12 238.12 221.12 236.84 228.78 232.42",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "222.98 184.69 222.04 186.87 214.3 191.34 214.33 202.77 228.78 194.43 228.75 183.58 228.74 183 228.74 181.37 222.98 184.69",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "228.78 197.71 214.33 206.05 214.33 204.77 228.78 196.43 228.78 197.71",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "228.78 199.1 228.78 200.39 221.12 204.81 221.12 203.52 228.78 199.1",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "228.78 197.71 214.33 206.05 214.33 204.77 228.78 196.43 228.78 197.71",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "228.78 199.1 228.78 200.39 221.12 204.81 221.12 203.52 228.78 199.1",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "222.98 151.38 222.04 153.55 214.3 158.03 214.33 169.46 228.78 161.12 228.75 150.27 228.74 149.69 228.74 148.06 222.98 151.38",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "228.78 164.4 214.33 172.74 214.33 171.45 228.78 163.11 228.78 164.4",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "228.78 165.79 228.78 167.07 221.12 171.49 221.12 170.21 228.78 165.79",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "228.78 164.4 214.33 172.74 214.33 171.45 228.78 163.11 228.78 164.4",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "228.78 165.79 228.78 167.07 221.12 171.49 221.12 170.21 228.78 165.79",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "222.98 118.07 222.04 120.24 214.3 124.71 214.33 136.14 228.78 127.8 228.75 116.95 228.74 116.37 228.74 114.74 222.98 118.07",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "228.78 131.08 214.33 139.42 214.33 138.14 228.78 129.8 228.78 131.08",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "228.78 132.47 228.78 133.76 221.12 138.18 221.12 136.9 228.78 132.47",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "228.78 131.08 214.33 139.42 214.33 138.14 228.78 129.8 228.78 131.08",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "228.78 132.47 228.78 133.76 221.12 138.18 221.12 136.9 228.78 132.47",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "251.25 201.63 250.31 203.81 242.56 208.28 242.59 219.71 257.04 211.37 257.01 200.52 257.01 199.94 257 198.31 251.25 201.63",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "257.04 214.65 242.59 222.99 242.59 221.71 257.04 213.37 257.04 214.65",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "257.04 216.04 257.04 217.32 249.38 221.75 249.38 220.46 257.04 216.04",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "257.04 214.65 242.59 222.99 242.59 221.71 257.04 213.37 257.04 214.65",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "257.04 216.04 257.04 217.32 249.38 221.75 249.38 220.46 257.04 216.04",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "251.25 168.32 250.31 170.49 242.56 174.97 242.59 186.4 257.04 178.05 257.01 167.21 257.01 166.63 257 165 251.25 168.32",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "257.04 181.34 242.59 189.68 242.59 188.39 257.04 180.05 257.04 181.34",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "257.04 182.73 257.04 184.01 249.38 188.43 249.38 187.15 257.04 182.73",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "257.04 181.34 242.59 189.68 242.59 188.39 257.04 180.05 257.04 181.34",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "257.04 182.73 257.04 184.01 249.38 188.43 249.38 187.15 257.04 182.73",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "251.25 135.01 250.31 137.18 242.56 141.65 242.59 153.08 257.04 144.74 257.01 133.89 257.01 133.31 257 131.68 251.25 135.01",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "257.04 148.02 242.59 156.36 242.59 155.08 257.04 146.74 257.04 148.02",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "257.04 149.41 257.04 150.7 249.38 155.12 249.38 153.84 257.04 149.41",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "257.04 148.02 242.59 156.36 242.59 155.08 257.04 146.74 257.04 148.02",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "257.04 149.41 257.04 150.7 249.38 155.12 249.38 153.84 257.04 149.41",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "251.25 101.69 250.31 103.86 242.56 108.34 242.59 119.77 257.04 111.43 257.01 100.58 257.01 100 257 98.37 251.25 101.69",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "257.04 114.71 242.59 123.05 242.59 121.77 257.04 113.42 257.04 114.71",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "257.04 116.1 257.04 117.38 249.38 121.8 249.38 120.52 257.04 116.1",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "257.04 114.71 242.59 123.05 242.59 121.77 257.04 113.42 257.04 114.71",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "257.04 116.1 257.04 117.38 249.38 121.8 249.38 120.52 257.04 116.1",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "194.08 234.77 193.15 236.94 185.4 241.41 185.43 252.84 199.88 244.5 199.85 233.65 199.84 233.07 199.84 231.44 194.08 234.77",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "199.88 247.78 185.43 256.12 185.43 254.84 199.88 246.5 199.88 247.78",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "199.88 249.17 199.88 250.46 192.22 254.88 192.22 253.59 199.88 249.17",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "199.88 247.78 185.43 256.12 185.43 254.84 199.88 246.5 199.88 247.78",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "199.88 249.17 199.88 250.46 192.22 254.88 192.22 253.59 199.88 249.17",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "194.08 201.45 193.15 203.63 185.4 208.1 185.43 219.53 199.88 211.19 199.85 200.34 199.84 199.76 199.84 198.13 194.08 201.45",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "199.88 214.47 185.43 222.81 185.43 221.53 199.88 213.18 199.88 214.47",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "199.88 215.86 199.88 217.14 192.22 221.56 192.22 220.28 199.88 215.86",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "199.88 214.47 185.43 222.81 185.43 221.53 199.88 213.18 199.88 214.47",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "199.88 215.86 199.88 217.14 192.22 221.56 192.22 220.28 199.88 215.86",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "194.08 168.14 193.15 170.31 185.4 174.78 185.43 186.21 199.88 177.87 199.85 167.03 199.84 166.44 199.84 164.81 194.08 168.14",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "199.88 181.15 185.43 189.5 185.43 188.21 199.88 179.87 199.88 181.15",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "199.88 182.55 199.88 183.83 192.22 188.25 192.22 186.97 199.88 182.55",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "199.88 181.15 185.43 189.5 185.43 188.21 199.88 179.87 199.88 181.15",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "199.88 182.55 199.88 183.83 192.22 188.25 192.22 186.97 199.88 182.55",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "194.08 134.82 193.15 137 185.4 141.47 185.43 152.9 199.88 144.56 199.85 133.71 199.84 133.13 199.84 131.5 194.08 134.82",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "199.88 147.84 185.43 156.18 185.43 154.9 199.88 146.56 199.88 147.84",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "199.88 149.23 199.88 150.51 192.22 154.94 192.22 153.65 199.88 149.23",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "199.88 147.84 185.43 156.18 185.43 154.9 199.88 146.56 199.88 147.84",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "199.88 149.23 199.88 150.51 192.22 154.94 192.22 153.65 199.88 149.23",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "165.19 251.52 164.25 253.7 156.5 258.17 156.53 269.6 170.98 261.26 170.95 250.41 170.95 249.83 170.94 248.2 165.19 251.52",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "170.98 264.54 156.53 272.88 156.53 271.6 170.98 263.25 170.98 264.54",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "170.98 265.93 170.98 267.21 163.32 271.63 163.32 270.35 170.98 265.93",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "170.98 264.54 156.53 272.88 156.53 271.6 170.98 263.25 170.98 264.54",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "170.98 265.93 170.98 267.21 163.32 271.63 163.32 270.35 170.98 265.93",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "165.19 218.21 164.25 220.38 156.5 224.86 156.53 236.28 170.98 227.94 170.95 217.1 170.95 216.51 170.94 214.89 165.19 218.21",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "170.98 231.22 156.53 239.57 156.53 238.28 170.98 229.94 170.98 231.22",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "170.98 232.62 170.98 233.9 163.32 238.32 163.32 237.04 170.98 232.62",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "170.98 231.22 156.53 239.57 156.53 238.28 170.98 229.94 170.98 231.22",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "170.98 232.62 170.98 233.9 163.32 238.32 163.32 237.04 170.98 232.62",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "165.19 184.9 164.25 187.07 156.5 191.54 156.53 202.97 170.98 194.63 170.95 183.78 170.95 183.2 170.94 181.57 165.19 184.9",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "170.98 197.91 156.53 206.25 156.53 204.97 170.98 196.63 170.98 197.91",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "170.98 199.3 170.98 200.59 163.32 205.01 163.32 203.72 170.98 199.3",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "170.98 197.91 156.53 206.25 156.53 204.97 170.98 196.63 170.98 197.91",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "170.98 199.3 170.98 200.59 163.32 205.01 163.32 203.72 170.98 199.3",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "165.19 151.58 164.25 153.75 156.5 158.23 156.53 169.66 170.98 161.32 170.95 150.47 170.95 149.89 170.94 148.26 165.19 151.58",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "170.98 164.6 156.53 172.94 156.53 171.66 170.98 163.31 170.98 164.6",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "170.98 165.99 170.98 167.27 163.32 171.69 163.32 170.41 170.98 165.99",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "170.98 164.6 156.53 172.94 156.53 171.66 170.98 163.31 170.98 164.6",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "170.98 165.99 170.98 167.27 163.32 171.69 163.32 170.41 170.98 165.99",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "136.29 268.28 135.35 270.45 127.6 274.93 127.63 286.36 142.08 278.01 142.05 267.17 142.05 266.59 142.04 264.96 136.29 268.28",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "142.08 281.3 127.63 289.64 127.63 288.35 142.08 280.01 142.08 281.3",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "142.08 282.69 142.08 283.97 134.42 288.39 134.42 287.11 142.08 282.69",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "142.08 281.3 127.63 289.64 127.63 288.35 142.08 280.01 142.08 281.3",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "142.08 282.69 142.08 283.97 134.42 288.39 134.42 287.11 142.08 282.69",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "136.29 234.97 135.35 237.14 127.6 241.61 127.63 253.04 142.08 244.7 142.05 233.85 142.05 233.27 142.04 231.64 136.29 234.97",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "142.08 247.98 127.63 256.32 127.63 255.04 142.08 246.7 142.08 247.98",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "142.08 249.37 142.08 250.66 134.42 255.08 134.42 253.79 142.08 249.37",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "142.08 247.98 127.63 256.32 127.63 255.04 142.08 246.7 142.08 247.98",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "142.08 249.37 142.08 250.66 134.42 255.08 134.42 253.79 142.08 249.37",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "136.29 201.65 135.35 203.83 127.6 208.3 127.63 219.73 142.08 211.39 142.05 200.54 142.05 199.96 142.04 198.33 136.29 201.65",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "142.08 214.67 127.63 223.01 127.63 221.73 142.08 213.38 142.08 214.67",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "142.08 216.06 142.08 217.34 134.42 221.76 134.42 220.48 142.08 216.06",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "142.08 214.67 127.63 223.01 127.63 221.73 142.08 213.38 142.08 214.67",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "142.08 216.06 142.08 217.34 134.42 221.76 134.42 220.48 142.08 216.06",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "136.29 168.34 135.35 170.51 127.6 174.99 127.63 186.41 142.08 178.07 142.05 167.23 142.05 166.64 142.04 165.02 136.29 168.34",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "142.08 181.35 127.63 189.7 127.63 188.41 142.08 180.07 142.08 181.35",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "142.08 182.75 142.08 184.03 134.42 188.45 134.42 187.17 142.08 182.75",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "142.08 181.35 127.63 189.7 127.63 188.41 142.08 180.07 142.08 181.35",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "142.08 182.75 142.08 184.03 134.42 188.45 134.42 187.17 142.08 182.75",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "107.39 285.04 106.45 287.21 98.7 291.69 98.73 303.11 113.18 294.77 113.15 283.93 113.15 283.34 113.14 281.71 107.39 285.04",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "113.18 298.05 98.73 306.39 98.73 305.11 113.18 296.77 113.18 298.05",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "113.18 299.45 113.18 300.73 105.52 305.15 105.52 303.87 113.18 299.45",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "113.18 298.05 98.73 306.39 98.73 305.11 113.18 296.77 113.18 298.05",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "113.18 299.45 113.18 300.73 105.52 305.15 105.52 303.87 113.18 299.45",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "107.39 251.72 106.45 253.9 98.7 258.37 98.73 269.8 113.18 261.46 113.15 250.61 113.15 250.03 113.14 248.4 107.39 251.72",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "113.18 264.74 98.73 273.08 98.73 271.8 113.18 263.46 113.18 264.74",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "113.18 266.13 113.18 267.42 105.52 271.84 105.52 270.55 113.18 266.13",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "113.18 264.74 98.73 273.08 98.73 271.8 113.18 263.46 113.18 264.74",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "113.18 266.13 113.18 267.42 105.52 271.84 105.52 270.55 113.18 266.13",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "107.39 218.41 106.45 220.58 98.7 225.06 98.73 236.49 113.18 228.14 113.15 217.3 113.15 216.72 113.14 215.09 107.39 218.41",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "113.18 231.43 98.73 239.77 98.73 238.48 113.18 230.14 113.18 231.43",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "113.18 232.82 113.18 234.1 105.52 238.52 105.52 237.24 113.18 232.82",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "113.18 231.43 98.73 239.77 98.73 238.48 113.18 230.14 113.18 231.43",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "113.18 232.82 113.18 234.1 105.52 238.52 105.52 237.24 113.18 232.82",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "107.39 185.1 106.45 187.27 98.7 191.74 98.73 203.17 113.18 194.83 113.15 183.98 113.15 183.4 113.14 181.77 107.39 185.1",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "113.18 198.11 98.73 206.45 98.73 205.17 113.18 196.83 113.18 198.11",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "113.18 199.5 113.18 200.79 105.52 205.21 105.52 203.93 113.18 199.5",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "113.18 198.11 98.73 206.45 98.73 205.17 113.18 196.83 113.18 198.11",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "113.18 199.5 113.18 200.79 105.52 205.21 105.52 203.93 113.18 199.5",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "78.49 301.8 77.55 303.97 69.8 308.44 69.83 319.87 84.28 311.53 84.25 300.68 84.25 300.1 84.25 298.47 78.49 301.8",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "84.28 314.81 69.83 323.15 69.83 321.87 84.28 313.53 84.28 314.81",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "84.28 316.2 84.28 317.49 76.63 321.91 76.63 320.62 84.28 316.2",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "84.28 314.81 69.83 323.15 69.83 321.87 84.28 313.53 84.28 314.81",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "84.28 316.2 84.28 317.49 76.63 321.91 76.63 320.62 84.28 316.2",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "78.49 268.48 77.55 270.65 69.8 275.13 69.83 286.56 84.28 278.22 84.25 267.37 84.25 266.79 84.25 265.16 78.49 268.48",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "84.28 281.5 69.83 289.84 69.83 288.56 84.28 280.21 84.28 281.5",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "84.28 282.89 84.28 284.17 76.63 288.59 76.63 287.31 84.28 282.89",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "84.28 281.5 69.83 289.84 69.83 288.56 84.28 280.21 84.28 281.5",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "84.28 282.89 84.28 284.17 76.63 288.59 76.63 287.31 84.28 282.89",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "78.49 235.17 77.55 237.34 69.8 241.81 69.83 253.24 84.28 244.9 84.25 234.06 84.25 233.47 84.25 231.84 78.49 235.17",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "84.28 248.18 69.83 256.52 69.83 255.24 84.28 246.9 84.28 248.18",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "84.28 249.57 84.28 250.86 76.63 255.28 76.63 254 84.28 249.57",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "84.28 248.18 69.83 256.52 69.83 255.24 84.28 246.9 84.28 248.18",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "84.28 249.57 84.28 250.86 76.63 255.28 76.63 254 84.28 249.57",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "78.49 201.85 77.55 204.03 69.8 208.5 69.83 219.93 84.28 211.59 84.25 200.74 84.25 200.16 84.25 198.53 78.49 201.85",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "84.28 214.87 69.83 223.21 69.83 221.93 84.28 213.59 84.28 214.87",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "84.28 216.26 84.28 217.54 76.63 221.97 76.63 220.68 84.28 216.26",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "84.28 214.87 69.83 223.21 69.83 221.93 84.28 213.59 84.28 214.87",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "84.28 216.26 84.28 217.54 76.63 221.97 76.63 220.68 84.28 216.26",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M232.79,126.71h0a6.48,6.48,0,0,0-5.39-3.56,2.39,2.39,0,0,0-.71.14l-100,57.43a4.71,4.71,0,0,0-2.36,4.05v74.84c0,2.69,3.1,5.26,6,4h0a.77.77,0,0,0,.19-.08l100-57.47a4.68,4.68,0,0,0,2.35-4.06V127.22A1.27,1.27,0,0,0,232.79,126.71Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.34,184.77v74.84c0,2.69,3.1,5.26,6,4h0a1.16,1.16,0,0,1-1.56-1.09V187.69a4.7,4.7,0,0,1,.79-2.58l-4.78-2.38A4.71,4.71,0,0,0,124.34,184.77Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.4,123.15a2.39,2.39,0,0,0-.71.14l-100,57.43a4.67,4.67,0,0,0-1.88,2l4.78,2.38a4.84,4.84,0,0,1,1.57-1.48l100-57.42a1.16,1.16,0,0,1,1.62.5h0A6.48,6.48,0,0,0,227.4,123.15Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M224.59,184.12c1.36-.78,2.47-.15,2.47,1.41l0,11.68a5.42,5.42,0,0,1-2.45,4.26l-86.23,49.78c-1.35.78-2.46.15-2.47-1.42l0-11.67a5.44,5.44,0,0,1,2.46-4.26Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "160.1 224.76 160.07 226.57 161.47 224.78 162.25 225.8 160.89 227.45 162.26 227.51 161.48 229.44 160.08 229.28 160.12 231.02 158.6 231.9 158.63 230.11 157.23 231.89 156.46 230.86 157.82 229.22 156.46 229.15 157.22 227.23 158.62 227.41 158.58 225.65 160.1 224.76",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "166.43 221.11 166.4 222.92 167.8 221.12 168.58 222.15 167.22 223.8 168.59 223.86 167.81 225.78 166.4 225.62 166.45 227.37 164.93 228.25 164.96 226.46 163.56 228.24 162.79 227.2 164.15 225.57 162.78 225.5 163.54 223.58 164.95 223.75 164.91 221.99 166.43 221.11",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "172.76 217.46 172.72 219.27 174.13 217.47 174.91 218.5 173.54 220.15 174.91 220.21 174.14 222.13 172.73 221.97 172.78 223.72 171.25 224.6 171.29 222.8 169.89 224.58 169.12 223.55 170.48 221.92 169.11 221.84 169.87 219.93 171.28 220.1 171.23 218.34 172.76 217.46",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "179.09 213.81 179.05 215.61 180.46 213.82 181.23 214.84 179.87 216.49 181.24 216.55 180.47 218.47 179.06 218.32 179.1 220.06 177.58 220.94 177.61 219.15 176.21 220.93 175.44 219.9 176.81 218.26 175.44 218.19 176.2 216.27 177.6 216.45 177.56 214.69 179.09 213.81",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "185.41 210.15 185.38 211.96 186.78 210.16 187.56 211.19 186.2 212.84 187.57 212.9 186.79 214.82 185.38 214.66 185.43 216.41 183.91 217.29 183.94 215.5 182.54 217.28 181.77 216.24 183.13 214.61 181.77 214.53 182.52 212.62 183.93 212.79 183.89 211.03 185.41 210.15",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "191.74 206.5 191.71 208.31 193.11 206.51 193.89 207.54 192.53 209.19 193.89 209.25 193.12 211.17 191.71 211.01 191.76 212.76 190.23 213.64 190.27 211.85 188.87 213.63 188.1 212.59 189.46 210.96 188.09 210.88 188.85 208.97 190.26 209.14 190.21 207.38 191.74 206.5",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "198.07 202.85 198.03 204.66 199.44 202.86 200.22 203.88 198.85 205.53 200.22 205.59 199.45 207.51 198.04 207.36 198.08 209.1 196.56 209.98 196.6 208.19 195.19 209.97 194.42 208.94 195.79 207.3 194.42 207.23 195.18 205.32 196.59 205.49 196.54 203.73 198.07 202.85",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "204.4 199.19 204.36 201 205.76 199.21 206.54 200.23 205.18 201.88 206.55 201.94 205.77 203.86 204.37 203.7 204.41 205.45 202.89 206.33 202.92 204.54 201.52 206.32 200.75 205.28 202.11 203.65 200.75 203.58 201.51 201.66 202.91 201.84 202.87 200.07 204.4 199.19",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.2,196.15l.13,0-.8,6.84h0l.79-6.84Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.17,189.32a2.23,2.23,0,0,0-1.5.34A5.93,5.93,0,0,0,178,194.3a3,3,0,0,0,.1.76,1.42,1.42,0,0,0,1.11,1.09l.13,0-.79,6.84,4.33-2.5-.83-5.91a6.41,6.41,0,0,0,1-1.66,4.94,4.94,0,0,0,.36-1.76,2.63,2.63,0,0,0-.21-1.08A1.38,1.38,0,0,0,182.17,189.32Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.17,189.32a2.23,2.23,0,0,0-1.5.34A5.93,5.93,0,0,0,178,194.3a3,3,0,0,0,.1.76,1.42,1.42,0,0,0,1.11,1.09l.13,0-.79,6.84,4.33-2.5-.83-5.91a6.41,6.41,0,0,0,1-1.66,4.94,4.94,0,0,0,.36-1.76,2.63,2.63,0,0,0-.21-1.08A1.38,1.38,0,0,0,182.17,189.32Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166,193.85l0,19.27,29.34-16.94-.06-19.27Zm17-.89a6.41,6.41,0,0,1-1,1.66l.83,5.91-4.33,2.5h0l.8-6.84-.13,0a1.42,1.42,0,0,1-1.11-1.09,3,3,0,0,1-.1-.76,5.93,5.93,0,0,1,2.68-4.64,2.23,2.23,0,0,1,1.5-.34,1.38,1.38,0,0,1,1,.8,2.63,2.63,0,0,1,.21,1.08A4.94,4.94,0,0,1,183,193Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166,193.85l0,19.27,29.34-16.94-.06-19.27Zm17-.89a6.41,6.41,0,0,1-1,1.66l.83,5.91-4.33,2.5h0l.8-6.84-.13,0a1.42,1.42,0,0,1-1.11-1.09,3,3,0,0,1-.1-.76,5.93,5.93,0,0,1,2.68-4.64,2.23,2.23,0,0,1,1.5-.34,1.38,1.38,0,0,1,1,.8,2.63,2.63,0,0,1,.21,1.08A4.94,4.94,0,0,1,183,193Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.57,190.05l0-9.28c0-5.12,3.6-11.39,8.06-14s8.1-.5,8.12,4.62l0,6.15,3.5-2,0-6.15c0-7.35-5.23-10.32-11.63-6.63S169,175.45,169,182.79l0,9.28Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.57,190.05l0-9.28c0-5.12,3.6-11.39,8.06-14s8.1-.5,8.12,4.62l0,6.15,3.5-2,0-6.15c0-7.35-5.23-10.32-11.63-6.63S169,175.45,169,182.79l0,9.28Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187,179.28,184,181.05a1,1,0,0,0-.44.75c0,.29.2.4.44.25l3.07-1.77a1,1,0,0,0,.44-.75C187.46,179.25,187.26,179.14,187,179.28Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.86,177.52c.12-.31,0-.57-.16-.59L185,176.7a.46.46,0,0,0-.22.06,1,1,0,0,0-.38.47c-.12.32,0,.58.17.6l2.65.23a.46.46,0,0,0,.22-.06A.94.94,0,0,0,187.86,177.52Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.57,174.49a1,1,0,0,0,.22-.2l2.65-3.3a.73.73,0,0,0,.16-.78.27.27,0,0,0-.38,0,.68.68,0,0,0-.22.2l-2.65,3.29a.74.74,0,0,0-.16.78C193.27,174.57,193.42,174.57,193.57,174.49Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.11,173.45,194,175.22a.94.94,0,0,0-.43.76c0,.28.19.39.43.25l3.07-1.77a1,1,0,0,0,.44-.76A.27.27,0,0,0,197.11,173.45Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M187,179.28,184,181.05a1,1,0,0,0-.44.75c0,.29.2.4.44.25l3.07-1.77a1,1,0,0,0,.44-.75C187.46,179.25,187.26,179.14,187,179.28Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.86,177.52c.12-.31,0-.57-.16-.59L185,176.7a.46.46,0,0,0-.22.06,1,1,0,0,0-.38.47c-.12.32,0,.58.17.6l2.65.23a.46.46,0,0,0,.22-.06A.94.94,0,0,0,187.86,177.52Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.57,174.49a1,1,0,0,0,.22-.2l2.65-3.3a.73.73,0,0,0,.16-.78.27.27,0,0,0-.38,0,.68.68,0,0,0-.22.2l-2.65,3.29a.74.74,0,0,0-.16.78C193.27,174.57,193.42,174.57,193.57,174.49Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.11,173.45,194,175.22a.94.94,0,0,0-.43.76c0,.28.19.39.43.25l3.07-1.77a1,1,0,0,0,.44-.76A.27.27,0,0,0,197.11,173.45Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M372,384.86a9.64,9.64,0,0,0-3.51-6.9v-4.27l-22.79-13.54,12-3a8.62,8.62,0,0,0-1.28,4.28,2.94,2.94,0,0,0,1.34,2.8h0l2.7,1.72.05,0h0a3.06,3.06,0,0,0,3-.31,9.5,9.5,0,0,0,4.3-7.46,3,3,0,0,0-1.21-2.73h0l0,0,0,0-2.74-1.73h0a2.51,2.51,0,0,0-2-.2v-.69l-1.46-.5-19.53,1v-3.45a5.71,5.71,0,0,0,.61-.29,3.29,3.29,0,0,0,1.94-2.68V324.33h-13.1v22.58a3.21,3.21,0,0,0,1.9,2.68,6.31,6.31,0,0,0,.64.31v2.9l-14.11-3.05L318,350v2.6h0l-2.74,1.74,0,0,0,0h0a3.1,3.1,0,0,0-1.21,2.74,9.38,9.38,0,0,0,2.13,5.49l-13.64,6.15V372a5.84,5.84,0,0,0-.56.28,9.47,9.47,0,0,0-4.3,7.45,2.94,2.94,0,0,0,1.34,2.8h0l2.69,1.72.06,0h0a3.09,3.09,0,0,0,3-.32,9.49,9.49,0,0,0,4.3-7.46,3,3,0,0,0-1.21-2.73h0l0,0,0,0-.8-.5,25.85-10.51a1.88,1.88,0,0,0,1,1.51l-2.33,20.33v2.76a9.56,9.56,0,0,0-3.56,6.93,3,3,0,0,0,1.34,2.81h0l2.7,1.72.05,0h0a3.07,3.07,0,0,0,3-.32,9.47,9.47,0,0,0,4.3-7.45,3,3,0,0,0-1.21-2.73h0l0,0,0,0-2.74-1.74h0a2.28,2.28,0,0,0-1.43-.31l3-21.19h0a6.5,6.5,0,0,0,1.89-.3h0L363.19,378l-1.4.89,0,0,0,0h0a3.07,3.07,0,0,0-1.21,2.73,9.47,9.47,0,0,0,4.31,7.46,3.09,3.09,0,0,0,3,.32h0l.06,0,2.69-1.72h0A3,3,0,0,0,372,384.86Zm-47.45-28,2,1.08-1.38.62A9.42,9.42,0,0,0,324.5,356.85ZM307,368l9.88-4.4h0l-13.35,5.95Zm18.3-8.16h0l7.44-3.31Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.33,218.22a5.51,5.51,0,0,0-.83-1.4,11.53,11.53,0,0,0-1.14-1.18,20.45,20.45,0,0,0-1.86-1.51,22.47,22.47,0,0,0-2.27-1.46,22.94,22.94,0,0,0-3.64-1.65q-.72-.26-1.44-.45c-.49-.14-1-.26-1.48-.36C387.7,201.82,353,186.8,353,186.8c-12.86-5.32-16.82-1.06-19.56,1.83-2.05,2.17-3.25,6.57-3.21,12.81a61.94,61.94,0,0,0,.47,6.83c.54,4.33,1.65,11.61,1.89,19.27a80.67,80.67,0,0,1-.15,8.23c-.55,7-2.31,13.65-6.46,17.72-6.14,6-25,2.46-34.17.27l-.13,0c-2.56-.62-4.33-1.12-4.82-1.26l-.1,0h-.06c-4.49-2.46-10.16-.15-9.64,4.43a5.37,5.37,0,0,0,.2,1c0,.11.07.23.11.35a9.29,9.29,0,0,0,1.21,2.29c2.56,3.64,4.49,4.86,5.73,7.82.15.35.28.72.41,1.13.83,2.62,1.26,6.55,1.25,13.65l-4.9,2.52a7.22,7.22,0,0,0-2.49,2.4,12.06,12.06,0,0,0-1.83,6.19,13.16,13.16,0,0,0,.33,3.37,10.87,10.87,0,0,0,.3,1.08,9.05,9.05,0,0,0,4,5.11l53.4,28.37a12.47,12.47,0,0,0,10.12.71,13,13,0,0,0,1.39-.6l37.41-18.95a18.91,18.91,0,0,0,9.72-11.95l21.42-79.13a3,3,0,0,0,2-.91,2.64,2.64,0,0,0,.61-1.47c0-.14,0-.28,0-.41A3.83,3.83,0,0,0,417.33,218.22Zm-75.79-9.38c0-.25.09-.49.14-.74.08-.48.17-.95.26-1.43-.08.43-.16.85-.23,1.28s-.12.59-.17.89-.14.91-.2,1.36c0,.21-.07.42-.1.63l.09-.58C341.4,209.78,341.46,209.31,341.54,208.84Zm3.12-11.47a44.2,44.2,0,0,0-1.47,4.21c.21-.71.43-1.4.67-2.08.1-.31.22-.6.34-.9s.3-.83.46-1.23.3-.68.46-1,.24-.58.38-.85c-.1.2-.19.42-.28.63C345,196.54,344.84,196.94,344.66,197.37Zm.9-2ZM342,206.42Zm43.28,92.93a16.76,16.76,0,0,1-1.48.86c.48-.24.94-.52,1.4-.8Zm-52.51-26.91L353,282.83l-20.21-10.39Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.9,382.53h0l2.7,1.72,0,0h0a3.09,3.09,0,0,0,3-.32,9.49,9.49,0,0,0,4.3-7.46,3,3,0,0,0-1.21-2.73h0l0,0,0,0-.8-.5,25.85-10.51a1.88,1.88,0,0,0,1,1.51l-2.33,20.33v2.76a9.56,9.56,0,0,0-3.56,6.93,3,3,0,0,0,1.34,2.81h0l2.7,1.72.05,0h0a3.07,3.07,0,0,0,3-.32,9.47,9.47,0,0,0,4.3-7.45,3,3,0,0,0-1.21-2.73h0l0,0,0,0-2.74-1.74h0a2.28,2.28,0,0,0-1.43-.31l3-21.19h0a6.5,6.5,0,0,0,1.89-.3h0L363.19,378l-1.4.89,0,0,0,0h0a3.07,3.07,0,0,0-1.21,2.73,9.47,9.47,0,0,0,4.31,7.46,3.09,3.09,0,0,0,3,.32h0l.06,0,2.69-1.72h0a3,3,0,0,0,1.35-2.8,9.64,9.64,0,0,0-3.51-6.9v-4.27l-22.79-13.54,12-3a8.62,8.62,0,0,0-1.28,4.28,2.94,2.94,0,0,0,1.34,2.8h0l2.7,1.72.05,0h0a3.06,3.06,0,0,0,3-.31,9.5,9.5,0,0,0,4.3-7.46,3,3,0,0,0-1.21-2.73h0l0,0,0,0-2.74-1.73h0a2.51,2.51,0,0,0-2-.2v-.69l-1.46-.5-19.53,1v-3.45a5.71,5.71,0,0,0,.61-.29,3.29,3.29,0,0,0,1.94-2.68V324.33h-13.1v22.58a3.21,3.21,0,0,0,1.9,2.68,6.31,6.31,0,0,0,.64.31v2.9l-14.11-3.05L318,350v2.6h0l-2.73,1.74,0,0,0,0h0a3.1,3.1,0,0,0-1.21,2.74,9.38,9.38,0,0,0,2.13,5.49l-13.64,6.15V372a5.84,5.84,0,0,0-.56.28,9.47,9.47,0,0,0-4.3,7.45A2.94,2.94,0,0,0,298.9,382.53ZM307,368l9.88-4.4h0l-13.35,5.95Zm17.47-11.11,2,1.08-1.38.62A9.42,9.42,0,0,0,324.5,356.85Zm8.27-.36-7.44,3.31h0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.46,359.17l2.16-3.71-2.81-1.78h0a3,3,0,0,0-3.12.26,9.47,9.47,0,0,0-4.3,7.45,2.94,2.94,0,0,0,1.34,2.8h0l2.76,1.76,2.28-3.91A10.35,10.35,0,0,0,364.46,359.17Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.5,355.73c2.38-1.38,4.32-.28,4.33,2.46a9.5,9.5,0,0,1-4.3,7.46c-2.38,1.37-4.33.27-4.33-2.47A9.47,9.47,0,0,1,363.5,355.73Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.31,358.11l-2.17-3.71,2.81-1.78h0a3,3,0,0,1,3.12.26,9.5,9.5,0,0,1,4.31,7.45,3,3,0,0,1-1.35,2.8h0l-2.75,1.76L319,361A10.3,10.3,0,0,1,317.31,358.11Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.26,354.67c-2.38-1.37-4.32-.27-4.33,2.47a9.47,9.47,0,0,0,4.31,7.45c2.38,1.38,4.32.27,4.33-2.47A9.47,9.47,0,0,0,318.26,354.67Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.77,348.93h8v13.8h0a2,2,0,0,1-1.18,1.64,6.24,6.24,0,0,1-5.66,0,2,2,0,0,1-1.17-1.65h0Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "361.77 352.8 361.77 356.09 340.78 361.38 340.78 354.42 361.77 352.8",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "361.77 352.8 360.31 352.3 340.78 353.33 340.78 354.42 361.77 352.8",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.88,382.63l-2.17-3.71,2.81-1.78h0a3,3,0,0,1,3.12.26,9.48,9.48,0,0,1,4.31,7.45,3,3,0,0,1-1.35,2.8h0l-2.75,1.76-2.28-3.91A10.11,10.11,0,0,1,363.88,382.63Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.83,379.19c-2.38-1.38-4.32-.27-4.33,2.46a9.47,9.47,0,0,0,4.31,7.46c2.38,1.37,4.32.27,4.33-2.47A9.45,9.45,0,0,0,364.83,379.19Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.93,392l2.16-3.71-2.81-1.78h0a3,3,0,0,0-3.12.26,9.49,9.49,0,0,0-4.3,7.45,3,3,0,0,0,1.34,2.81h0l2.76,1.76,2.28-3.9A10.54,10.54,0,0,0,335.93,392Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335,388.59c2.38-1.37,4.32-.27,4.33,2.47a9.47,9.47,0,0,1-4.3,7.45c-2.39,1.38-4.33.28-4.34-2.47A9.54,9.54,0,0,1,335,388.59Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.63,377.5l2.16-3.71L305,372h0a3,3,0,0,0-3.12.26,9.47,9.47,0,0,0-4.3,7.45,2.94,2.94,0,0,0,1.34,2.8h0l2.76,1.76,2.28-3.91A10.35,10.35,0,0,0,305.63,377.5Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.67,374.06c2.38-1.38,4.32-.28,4.33,2.46a9.49,9.49,0,0,1-4.3,7.46c-2.39,1.37-4.33.27-4.34-2.47A9.51,9.51,0,0,1,304.67,374.06Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "366.82 374.61 366.82 379.94 338.71 364.75 338.71 357.4 366.82 374.61",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "368.44 373.69 340.32 356.99 338.71 357.4 366.82 374.61 368.44 373.69",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "368.44 379.02 366.82 379.94 366.82 374.61 368.44 373.69 368.44 379.02",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "336.82 357.4 333.4 384.57 333.4 389.43 336.82 365.05 336.82 357.4",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 331.42,
    y: 384.57,
    width: 1.98,
    height: 4.86,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "331.42 384.57 334.53 357.4 336.82 357.4 333.4 384.57 331.42 384.57",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "303.56 369.51 303.56 374.61 332.77 362.73 332.77 356.49 303.56 369.51",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "302.42 373.86 303.56 374.61 303.56 369.51 302.42 368.77 302.42 373.86",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "307.03 367.96 303.56 369.51 302.42 368.77 332.77 355.1 332.77 356.49 307.03 367.96",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "317.98 350.02 317.98 353.36 326.5 357.93 332.77 355.1 332.77 353.73 317.98 350.02",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "317.98 350.02 318.66 349.75 332.77 352.8 332.77 353.73 317.98 350.02",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.23,324.33h13.1v22.58h0a3.29,3.29,0,0,1-1.94,2.68,10.18,10.18,0,0,1-9.26,0,3.21,3.21,0,0,1-1.9-2.68h0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.61,288a8.36,8.36,0,0,0,2.83,2.68l53.4,28.37a12.54,12.54,0,0,0,11.51.11l37.41-18.95a18.91,18.91,0,0,0,9.72-12l18-66.68.91.28a7.31,7.31,0,0,0,2.36.36l.1,0-21.42,79.13a18.91,18.91,0,0,1-9.72,11.95l-37.41,18.95a12.51,12.51,0,0,1-11.51-.11l-53.4-28.37C276.11,300.74,275.61,292.58,278.61,288Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.61,288a8.36,8.36,0,0,0,2.83,2.68l53.4,28.37a12.54,12.54,0,0,0,11.51.11l37.41-18.95a18.91,18.91,0,0,0,9.72-12l18-66.68.91.28a7.31,7.31,0,0,0,2.36.36l.1,0-21.42,79.13a18.91,18.91,0,0,1-9.72,11.95l-37.41,18.95a12.51,12.51,0,0,1-11.51-.11l-53.4-28.37C276.11,300.74,275.61,292.58,278.61,288Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.1,285.62l38.69-19.85,51,26.21c-1.66.4-3.34.74-5,1.07-4.38.88-8.85,1.85-12.66,4.19s-6.88,6.35-6.91,10.82l1.37,10.52h0l-1.19.6a12.54,12.54,0,0,1-11.51-.11l-53.4-28.37a8.36,8.36,0,0,1-2.83-2.68A7.22,7.22,0,0,1,281.1,285.62Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.1,285.62l38.69-19.85,51,26.21c-1.66.4-3.34.74-5,1.07-4.38.88-8.85,1.85-12.66,4.19s-6.88,6.35-6.91,10.82l1.37,10.52h0l-1.19.6a12.54,12.54,0,0,1-11.51-.11l-53.4-28.37a8.36,8.36,0,0,1-2.83-2.68A7.22,7.22,0,0,1,281.1,285.62Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.73,252.43s31.06,9.13,39.28,1.06c10.22-10,5.94-35.32,4.72-45.22s0-16.75,2.74-19.64,6.7-7.15,19.56-1.82c-13,6.69-14.69,38.53-10.57,51.31-10.21,10.5-9.51,26.77-9.7,34.32,0,0-26.54,6.48-40.4,14.09Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.73,252.43s31.06,9.13,39.28,1.06c10.22-10,5.94-35.32,4.72-45.22s0-16.75,2.74-19.64,6.7-7.15,19.56-1.82c-13,6.69-14.69,38.53-10.57,51.31-10.21,10.5-9.51,26.77-9.7,34.32,0,0-26.54,6.48-40.4,14.09Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.36,286.53,286,283.1c0-17.47-2.58-15.75-7.39-22.6s2.56-11.12,8.12-8.07S294.53,264.63,292.36,286.53Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.36,286.53,286,283.1c0-17.47-2.58-15.75-7.39-22.6s2.56-11.12,8.12-8.07S294.53,264.63,292.36,286.53Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353,186.81s34.8,15.07,51.74,23.44l-1.24,6.18L348,191.23A15,15,0,0,1,353,186.81Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353,186.81s34.8,15.07,51.74,23.44l-1.24,6.18L348,191.23A15,15,0,0,1,353,186.81Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.46,238.12c-3.51-10.91-2.8-35.7,5.58-46.89l55.49,25.2L390.85,280l-20.1,12-38-19.54C333,264.89,332.25,248.62,342.46,238.12Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.8,250.87c-.94-.54-1.71-.11-1.71,1a3.77,3.77,0,0,0,1.7,2.95c.94.54,1.71.1,1.71-1A3.75,3.75,0,0,0,376.8,250.87Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.21,245.82c-.94-.54-1.71-.11-1.71,1a3.75,3.75,0,0,0,1.7,2.94c.94.54,1.71.11,1.71-1A3.74,3.74,0,0,0,368.21,245.82Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.62,240.78c-.94-.55-1.7-.11-1.71,1a3.75,3.75,0,0,0,1.7,2.94c.94.55,1.71.11,1.71-1A3.7,3.7,0,0,0,359.62,240.78Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351,235.73c-.94-.54-1.71-.11-1.71,1a3.74,3.74,0,0,0,1.7,3c.94.54,1.7.1,1.71-1A3.75,3.75,0,0,0,351,235.73Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M376.8,250.87c-.94-.54-1.71-.11-1.71,1a3.77,3.77,0,0,0,1.7,2.95c.94.54,1.71.1,1.71-1A3.75,3.75,0,0,0,376.8,250.87Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.21,245.82c-.94-.54-1.71-.11-1.71,1a3.75,3.75,0,0,0,1.7,2.94c.94.54,1.71.11,1.71-1A3.74,3.74,0,0,0,368.21,245.82Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.62,240.78c-.94-.55-1.7-.11-1.71,1a3.75,3.75,0,0,0,1.7,2.94c.94.55,1.71.11,1.71-1A3.7,3.7,0,0,0,359.62,240.78Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351,235.73c-.94-.54-1.71-.11-1.71,1a3.74,3.74,0,0,0,1.7,3c.94.54,1.7.1,1.71-1A3.75,3.75,0,0,0,351,235.73Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M353.08,297.24c3.81-2.34,8.28-3.31,12.66-4.19,1.67-.33,3.35-.67,5-1.07a30.84,30.84,0,0,0,7.76-2.83c6.13-3.39,10.25-9.72,12.23-16.45s2-13.87,1.6-20.87-1.28-14-1.07-21c.12-4.08.74-8.44,3.5-11.45s7.44-4,11.6-3.49a23.34,23.34,0,0,1,4,.94l1.84,2.16-.71,2.61-18,66.68a18.91,18.91,0,0,1-8.29,11.13c-.47.29-.94.57-1.43.82l-36.22,18.35-1.37-10.52C346.2,303.59,349.28,299.59,353.08,297.24Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.08,297.24c3.81-2.34,8.28-3.31,12.66-4.19,1.67-.33,3.35-.67,5-1.07a30.84,30.84,0,0,0,7.76-2.83c6.13-3.39,10.25-9.72,12.23-16.45s2-13.87,1.6-20.87-1.28-14-1.07-21c.12-4.08.74-8.44,3.5-11.45s7.44-4,11.6-3.49a23.34,23.34,0,0,1,4,.94l1.84,2.16-.71,2.61-18,66.68a18.91,18.91,0,0,1-8.29,11.13c-.47.29-.94.57-1.43.82l-36.22,18.35-1.37-10.52C346.2,303.59,349.28,299.59,353.08,297.24Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353,290.08c13.25-3.78,26.27-4.27,31.07-13.79s5.14-22.65,2.74-45.48a34.65,34.65,0,0,1,.21-8.84c1.41-8.55,6.55-12.2,12.46-12.29a23,23,0,0,1,15.85,6,7.18,7.18,0,0,1,2,2.58,3.08,3.08,0,0,1-.39,3.09,3,3,0,0,1-2,.91l-.1,0a7.31,7.31,0,0,1-2.36-.36l-.91-.28c-1.62-.51-3.21-1.12-4.86-1.52a10.6,10.6,0,0,0-6,0,6.35,6.35,0,0,0-3.83,4.27c-5.59,18.25,1.49,37.86-4.79,52.93-5.14,13.7-22.9,19.39-35.43,23.46h0a7.73,7.73,0,0,0,3.13-2.28,5.27,5.27,0,0,0-.49-6.35A6.91,6.91,0,0,0,353,290.08Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353,290.08c13.25-3.78,26.27-4.27,31.07-13.79s5.14-22.65,2.74-45.48a34.65,34.65,0,0,1,.21-8.84c1.41-8.55,6.55-12.2,12.46-12.29a23,23,0,0,1,15.85,6,7.18,7.18,0,0,1,2,2.58,3.08,3.08,0,0,1-.39,3.09,3,3,0,0,1-2,.91l-.1,0a7.31,7.31,0,0,1-2.36-.36l-.91-.28c-1.62-.51-3.21-1.12-4.86-1.52a10.6,10.6,0,0,0-6,0,6.35,6.35,0,0,0-3.83,4.27c-5.59,18.25,1.49,37.86-4.79,52.93-5.14,13.7-22.9,19.39-35.43,23.46h0a7.73,7.73,0,0,0,3.13-2.28,5.27,5.27,0,0,0-.49-6.35A6.91,6.91,0,0,0,353,290.08Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.84,299.45a19.79,19.79,0,0,1,3.39-5.94,10.18,10.18,0,0,1,5.8-3.43,6.91,6.91,0,0,1,6.27,2,5.27,5.27,0,0,1,.49,6.35,7.73,7.73,0,0,1-3.13,2.28,29.07,29.07,0,0,0-2.91,1.43,12.33,12.33,0,0,0-5,7.07,36.89,36.89,0,0,0-1.16,8.77l0,.57-6.21-3.45A38,38,0,0,1,343.84,299.45Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.84,299.45a19.79,19.79,0,0,1,3.39-5.94,10.18,10.18,0,0,1,5.8-3.43,6.91,6.91,0,0,1,6.27,2,5.27,5.27,0,0,1,.49,6.35,7.73,7.73,0,0,1-3.13,2.28,29.07,29.07,0,0,0-2.91,1.43,12.33,12.33,0,0,0-5,7.07,36.89,36.89,0,0,0-1.16,8.77l0,.57-6.21-3.45A38,38,0,0,1,343.84,299.45Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.33,218.22a7.18,7.18,0,0,0-2-2.58,22.64,22.64,0,0,0-10.69-5.43c-17-8.39-51.64-23.4-51.64-23.4a11.55,11.55,0,0,0-1.3.79,11.55,11.55,0,0,1,1.3-.79c-12.86-5.33-16.82-1.07-19.56,1.82s-4,9.75-2.74,19.64,5.5,35.19-4.72,45.22c-8.22,8.07-39.28-1.06-39.28-1.06-5.56-3.05-12.94,1.21-8.12,8.07s7.4,5.13,7.39,22.6l-4.9,2.52a7.22,7.22,0,0,0-2.49,2.4c-3,4.56-2.5,12.72,2.83,15.75l53.4,28.37a12.51,12.51,0,0,0,11.51.11l37.41-18.95a18.91,18.91,0,0,0,9.72-11.95l21.42-79.13a3,3,0,0,0,2-.91A3.08,3.08,0,0,0,417.33,218.22Zm-25.19,73.57c-.14.27-.29.53-.43.79C391.85,292.32,392,292.06,392.14,291.79Zm-.91,1.6c-.18.29-.37.57-.57.85C390.86,294,391.05,293.68,391.23,293.39Zm-41-104.58q-.51.47-1,1Q349.71,189.27,350.22,188.81Zm1.21-1a11.69,11.69,0,0,0-1,.77A11.69,11.69,0,0,1,351.43,187.82ZM348,191.23c.34-.45.69-.88,1.06-1.29C348.73,190.35,348.38,190.78,348,191.23Zm-4.9,10.53a64.69,64.69,0,0,0-2,9.54A64.69,64.69,0,0,1,343.14,201.76Zm4.9-10.53c-.25.34-.5.69-.74,1.05C347.54,191.92,347.79,191.57,348,191.23Zm-.78,1.12c-.24.37-.47.74-.7,1.13C346.79,193.09,347,192.72,347.26,192.35Zm-.71,1.14a37.48,37.48,0,0,0-3.41,8.25A37.48,37.48,0,0,1,346.55,193.49Zm-5.4,18c-.07.48-.12,1-.18,1.45C341,212.46,341.08,212,341.15,211.5Zm-.21,1.78c-.05.46-.1.93-.14,1.4C340.84,214.21,340.89,213.75,340.94,213.28Zm-.17,1.74c0,.48-.08.95-.11,1.43C340.69,216,340.73,215.5,340.77,215Zm-.12,1.54c-.1,1.49-.15,3-.17,4.43C340.5,219.53,340.56,218.05,340.65,216.56Zm-.18,5v0ZM342.11,237c0-.13-.07-.27-.1-.41C342,236.68,342.08,236.82,342.11,237Zm-.31-1.26c0-.17-.08-.34-.11-.51C341.72,235.35,341.76,235.52,341.8,235.69Zm-.29-1.35c0-.19-.07-.37-.1-.56C341.44,234,341.48,234.15,341.51,234.34Zm-.25-1.44-.09-.59Zm-.22-1.54c0-.19-.06-.38-.08-.57C341,231,341,231.17,341,231.36Zm-.23-2-.06-.66Zm-.15-1.72c0-.27,0-.54-.05-.81C340.63,227.11,340.64,227.39,340.66,227.65Zm-.1-1.66,0-.89Zm-.06-1.68c0-.32,0-.64,0-1C340.48,223.67,340.49,224,340.5,224.31Zm22,63.43h0l-29.74-15.3h0Zm-16.15,31.44,1.19-.6,36.22-18.35c.49-.25,1-.53,1.43-.82s.85-.56,1.25-.87a18.07,18.07,0,0,1-2.68,1.69Zm40.38-20.84c.36-.28.7-.57,1-.87C387.43,297.77,387.09,298.06,386.73,298.34Zm1.43-1.22c.3-.28.59-.58.87-.88C388.75,296.54,388.46,296.84,388.16,297.12Zm2-2.24q-.35.45-.72.87Q389.85,295.33,390.19,294.88Zm2.42-4.15c.09-.21.2-.42.28-.64C392.81,290.31,392.7,290.52,392.61,290.73Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.18,324.77c6.13-2.64,14.46-12.94,18.64-18.14,5.3-6.6,4.71-21,3.51-27.55L291.19,275c-1.49,14.28-14.61,23.63-14.61,23.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.8,372.29c.2,4.82,0,10.47,0,10.47l2.8.16a6.76,6.76,0,0,1,6,4.46l.07.17a2.64,2.64,0,0,0,3.27,1.62h0a2.59,2.59,0,0,0,1.59-1.38L241,375.71Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.7,414.21c-7.33,3.12-18.55,3.74-23.2-3.74v2c4.65,7.48,15.87,6.87,23.2,3.74s5.72-8.24,12.29-11a17.86,17.86,0,0,0,6.41-4c0-.6.12-1.35.23-2.21a22.5,22.5,0,0,1-6.64,4.23C227.42,406,229,411.08,221.7,414.21Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.63,392.34a10.55,10.55,0,0,1,0-4.32,2.31,2.31,0,0,0-.33-1.91l-.55-.54-.26,2.22a2.59,2.59,0,0,1-1.59,1.38,2.64,2.64,0,0,1-3.27-1.62l-.07-.17a6.76,6.76,0,0,0-6-4.46l-2.84-.16a2.06,2.06,0,0,0-2,1.26c-2.92,7.05-10.27,14.89-15.94,18.47-4.16-.09-9.31,3.36-9.31,7.56v.42c4.65,7.48,15.87,6.86,23.2,3.74s5.72-8.25,12.29-11a22.5,22.5,0,0,0,6.64-4.23A24.41,24.41,0,0,0,240.63,392.34Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.44,398.13a.93.93,0,0,0,1.3.11.92.92,0,0,0,.15-1.28,10.61,10.61,0,0,0-9.57-4.2c-.39.48-.79,1-1.2,1.43A10.22,10.22,0,0,1,226.44,398.13Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.33,394.89a.93.93,0,0,0,1.3.12.92.92,0,0,0,.15-1.28,11.15,11.15,0,0,0-10-4.31c-.35.52-.72,1-1.1,1.56C223.28,390.73,226.47,391.41,229.33,394.89Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.44,401.29a.93.93,0,0,0,1.3.12.94.94,0,0,0,.15-1.29,10.64,10.64,0,0,0-9.32-4.22c-.47.5-.95,1-1.43,1.45A10.24,10.24,0,0,1,223.44,401.29Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.81,402.49c-4.16-.09-9.31,3.36-9.31,7.56v.42c4.58,7.36,15.53,6.88,22.86,3.87C220.8,404.27,211.13,402.46,207.81,402.49Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.35,404.31a.93.93,0,0,0,1.45-1.17,10.63,10.63,0,0,0-9.34-4.22c-.59.52-1.17,1-1.75,1.47C214.29,400.14,217.49,400.82,220.35,404.31Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.9,381.57c.21,4.81,0,10.47,0,10.47l2.8.16a6.78,6.78,0,0,1,6,4.46l.06.17a2.64,2.64,0,0,0,3.27,1.62h0a2.59,2.59,0,0,0,1.59-1.38L290.05,385Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.8,423.48c-7.33,3.13-18.54,3.74-23.2-3.73v2c4.66,7.48,15.87,6.87,23.2,3.74s5.72-8.24,12.29-11a17.67,17.67,0,0,0,6.41-4c0-.59.13-1.34.23-2.2a22.7,22.7,0,0,1-6.64,4.23C276.52,415.24,278.13,420.36,270.8,423.48Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.73,401.62a10.31,10.31,0,0,1,0-4.32,2.3,2.3,0,0,0-.34-1.92l-.54-.53-.27,2.22a2.59,2.59,0,0,1-1.59,1.38,2.64,2.64,0,0,1-3.27-1.62l-.06-.17a6.78,6.78,0,0,0-6-4.46l-2.84-.16a2.06,2.06,0,0,0-2,1.26c-2.92,7.05-10.27,14.89-15.94,18.47-4.16-.09-9.31,3.36-9.31,7.56v.42c4.66,7.47,15.87,6.86,23.2,3.73s5.72-8.24,12.29-11a22.7,22.7,0,0,0,6.64-4.23A24,24,0,0,0,289.73,401.62Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.54,407.41a.93.93,0,0,0,1.3.11.91.91,0,0,0,.15-1.28,10.6,10.6,0,0,0-9.57-4.2c-.39.48-.79,1-1.19,1.43A10.2,10.2,0,0,1,275.54,407.41Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.43,404.17a.93.93,0,0,0,1.3.12.91.91,0,0,0,.15-1.28,11.13,11.13,0,0,0-10-4.31c-.35.52-.72,1-1.1,1.56C272.38,400,275.57,400.69,278.43,404.17Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.54,410.57A.93.93,0,0,0,274,409.4a10.62,10.62,0,0,0-9.32-4.22c-.47.5-.95,1-1.43,1.45A10.23,10.23,0,0,1,272.54,410.57Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.91,411.77c-4.16-.09-9.31,3.36-9.31,7.56v.42c4.59,7.36,15.54,6.87,22.87,3.87C269.9,413.55,260.24,411.73,256.91,411.77Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.45,413.59a.93.93,0,0,0,1.45-1.17,10.61,10.61,0,0,0-9.34-4.22c-.58.52-1.17,1-1.74,1.47C263.39,409.42,266.59,410.1,269.45,413.59Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.75,353.73c-2.35,9.93-3.94,16.18-8.26,29.53,0,0-16.71,3.58-23.3-2.94L229.71,344Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.49,356.58c-.63,10.19-.26,19.37-2.26,33.27,0,0-14.24,4.72-21.84-.59L269.14,365Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "348.21 327.12 345.09 325.31 345.09 347.34 275.08 387.82 275.08 369.35 271.95 371.16 268.83 369.35 268.83 457.73 271.95 459.53 275.08 457.73 275.08 394.73 345.09 354.3 345.09 413.68 348.21 415.49 351.34 413.68 351.34 325.31 348.21 327.12",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "146.79 313.49 146.79 295.02 143.67 296.82 140.54 295.02 140.54 383.39 143.67 385.2 146.79 383.39 146.79 320.39 219.93 278.16 219.93 274.81 216.81 273 146.79 313.49",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "143.67 296.82 143.67 385.2 146.79 383.39 146.79 295.02 143.67 296.82",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "143.67 296.82 143.67 385.2 140.54 383.39 140.54 295.02 143.67 296.82",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "146.79 320.39 219.93 278.16 219.93 274.81 146.79 317.03 146.79 320.39",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "146.79 313.49 216.81 273 219.93 274.81 146.79 317.03 146.79 313.49",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "348.21 327.12 348.21 415.49 351.34 413.68 351.34 325.31 348.21 327.12",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "348.21 327.12 348.21 415.49 345.09 413.68 345.09 325.31 348.21 327.12",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "271.95 371.16 271.95 459.53 275.08 457.73 275.08 369.35 271.95 371.16",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "271.95 371.16 271.95 459.53 268.83 457.73 268.83 369.35 271.95 371.16",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "275.08 394.73 348.21 352.5 348.21 349.14 275.08 391.37 275.08 394.73",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "275.08 387.82 345.09 347.34 348.21 349.14 275.08 391.37 275.08 387.82",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "348.21 327.12 348.21 415.49 351.34 413.68 351.34 325.31 348.21 327.12",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "348.21 327.12 348.21 415.49 345.09 413.68 345.09 325.31 348.21 327.12",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "271.95 371.16 271.95 459.53 275.08 457.73 275.08 369.35 271.95 371.16",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "271.95 371.16 271.95 459.53 268.83 457.73 268.83 369.35 271.95 371.16",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "275.08 394.73 348.21 352.5 348.21 349.14 275.08 391.37 275.08 394.73",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "275.08 387.82 345.09 347.34 348.21 349.14 275.08 391.37 275.08 387.82",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "143.67 296.82 143.67 385.2 146.79 383.39 146.79 295.02 143.67 296.82",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "143.67 296.82 143.67 385.2 140.54 383.39 140.54 295.02 143.67 296.82",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "146.79 320.39 219.93 278.16 219.93 274.81 146.79 317.03 146.79 320.39",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "146.79 313.49 216.81 273 219.93 274.81 146.79 317.03 146.79 313.49",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "351.33 316.77 219.93 240.88 140.54 286.74 140.54 295.02 271.95 371.16 351.34 325.31 351.34 316.76 351.33 316.77",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "271.95 362.63 140.54 286.74 219.93 240.88 351.34 316.77 271.95 362.63",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "271.95 371.16 140.54 295.02 140.54 286.74 271.95 362.63 271.95 371.16",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "271.95 362.62 351.34 316.76 351.34 325.31 271.95 371.16 271.95 362.62",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "271.95 362.63 140.54 286.74 219.93 240.88 351.34 316.77 271.95 362.63",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "271.95 362.62 351.34 316.76 351.34 325.31 271.95 371.16 271.95 362.62",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "271.95 371.16 140.54 295.02 140.54 286.74 271.95 362.63 271.95 371.16",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.38,293.38l32.39-18.82a7.32,7.32,0,0,1,6.65,0l53.44,30.86a2.41,2.41,0,0,1,1.37,1.83h0v2.05h0a1.26,1.26,0,0,1,0,.43.08.08,0,0,1,0,0,2.33,2.33,0,0,1-.22.45l0,.05a2.75,2.75,0,0,1-.4.45l0,0a3.9,3.9,0,0,1-.59.43L264.5,330a4.86,4.86,0,0,1-.93.41l-.36.11-.47.12-.58.1-.13,0c-.27,0-.53,0-.8,0h-.12c-.27,0-.53,0-.79,0l-.11,0a6.35,6.35,0,0,1-.76-.13l-.14,0c-.22-.06-.44-.12-.65-.2l-.11,0a4.79,4.79,0,0,1-.72-.34l-53.44-30.85a4.12,4.12,0,0,1-.61-.43c-.06-.05-.09-.11-.15-.17a3.84,3.84,0,0,1-.28-.3,1,1,0,0,1-.1-.21,2.19,2.19,0,0,1-.16-.3c0-.07,0-.15,0-.22a1.57,1.57,0,0,1-.05-.3v-1.9A2.34,2.34,0,0,1,204.38,293.38Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.23,307.24a1.64,1.64,0,0,1-.06.58s0,0,0,0a2.15,2.15,0,0,1-.22.46l0,.05a2.7,2.7,0,0,1-.4.44l0,0a3.87,3.87,0,0,1-.59.42L264.5,328.09a6.54,6.54,0,0,1-.93.41l-.36.1a3.59,3.59,0,0,1-.47.12,5.4,5.4,0,0,1-.58.1l-.13,0a7.14,7.14,0,0,1-.8,0h-.12a6.85,6.85,0,0,1-.79,0h-.11c-.26,0-.51-.08-.76-.13l-.14,0c-.22-.05-.44-.12-.65-.19l-.11,0a4.79,4.79,0,0,1-.72-.34l-53.44-30.86a4.08,4.08,0,0,1-.61-.42c-.06-.06-.09-.12-.15-.17a2.7,2.7,0,0,1-.28-.31.93.93,0,0,1-.1-.2,1.82,1.82,0,0,1-.16-.31c0-.07,0-.14,0-.22a1.57,1.57,0,0,1-.05-.3v1.9a1.57,1.57,0,0,0,.05.3c0,.07,0,.15,0,.22a2.19,2.19,0,0,0,.16.3,1,1,0,0,0,.1.21,3.84,3.84,0,0,0,.28.3c.06.06.09.12.15.17a4.12,4.12,0,0,0,.61.43L257.83,330a4.79,4.79,0,0,0,.72.34l.11,0c.21.08.43.14.65.2l.14,0a6.35,6.35,0,0,0,.76.13l.11,0c.26,0,.52,0,.79,0h.12c.27,0,.53,0,.8,0l.13,0,.58-.1.47-.12.36-.11a4.86,4.86,0,0,0,.93-.41l32.39-18.82a3.9,3.9,0,0,0,.59-.43l0,0a2.75,2.75,0,0,0,.4-.45l0-.05a2.33,2.33,0,0,0,.22-.45.08.08,0,0,0,0,0,1.26,1.26,0,0,0,0-.43h0v-2.05Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.54,295.3l51.92,30,.2.09.11,0a2.76,2.76,0,0,0,.41.12l.29.06.19,0c.14,0,.29,0,.51,0h0c.16,0,.32,0,.53,0a2,2,0,0,0,.34-.06c.09,0,.42-.11.42-.11a1.44,1.44,0,0,0,.36-.15l16.7-9.71-53.62-31Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.23,325.64h0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.93,287.06l-9.77,5.74a1,1,0,0,0,0,1.71l14.6,8.43a1.63,1.63,0,0,0,1.64,0l9.77-5.74a1,1,0,0,0,0-1.71l-14.6-8.43A1.63,1.63,0,0,0,256.93,287.06Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.54,295.3l51.92,30,.2.09.11,0a2.76,2.76,0,0,0,.41.12l.29.06.19,0c.14,0,.29,0,.51,0h0c.16,0,.32,0,.53,0a2,2,0,0,0,.34-.06c.09,0,.42-.11.42-.11a1.44,1.44,0,0,0,.36-.15l16.7-9.71-53.62-31Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.93,287.06l-9.77,5.74a1,1,0,0,0,0,1.71l14.6,8.43a1.63,1.63,0,0,0,1.64,0l9.77-5.74a1,1,0,0,0,0-1.71l-14.6-8.43A1.63,1.63,0,0,0,256.93,287.06Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.32,267.89c-3.92,5.68,5.4,13.84,9.38,11.87S258.53,263.68,250.32,267.89Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.32,267.89c-3.92,5.68,5.4,13.84,9.38,11.87S258.53,263.68,250.32,267.89Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.88,220.44l-10.73,32.14-24,18.79a10.34,10.34,0,0,1-4.79.74l-9.63-.79a5.46,5.46,0,0,0-3.23.76L226,275.42a5.87,5.87,0,0,0-1.46,1.26l-2.7,3.2a2,2,0,0,0,.37,2.95l1.69,1.22a6.07,6.07,0,0,0,6.24.48l4.26-2.15,8.81,1v2.3l-2.38,2.05a2.54,2.54,0,0,0,.05,3.9h0s5.9-1.74,11.23-10.29l28.18-13.92a20,20,0,0,0,10.16-11.76l16-49.28-6.3.79A19.71,19.71,0,0,0,283.88,220.44Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.86,205.15A21.8,21.8,0,0,0,282,219.81l-10.54,31.56L257.9,262a10.49,10.49,0,0,1,8,14.72l15.21-7.52a22.13,22.13,0,0,0,11.18-12.93l17-52.27Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.59,267.35A10.76,10.76,0,0,0,257.9,262l-7.58,5.92a9.44,9.44,0,0,1,9.38,11.87l6.22-3.07A10.78,10.78,0,0,0,265.59,267.35Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.86,205.15A21.8,21.8,0,0,0,282,219.81l-10.54,31.56L257.9,262a10.49,10.49,0,0,1,8,14.72l15.21-7.52a22.13,22.13,0,0,0,11.18-12.93l17-52.27Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.59,267.35A10.76,10.76,0,0,0,257.9,262l-7.58,5.92a9.44,9.44,0,0,1,9.38,11.87l6.22-3.07A10.78,10.78,0,0,0,265.59,267.35Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.44,251.37c6.79.15,10,3.65,10.86,5.4.31-10.13-10.06-7.8-10.06-7.8Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.65,255.65h0l1.28-.64h0a1.58,1.58,0,0,1,1.43.09l53.81,31.29a6.47,6.47,0,0,1,3.15,4.6l5.53,35.18a1.59,1.59,0,0,1-.9,1.7h0l-1.24.61h0a1.61,1.61,0,0,1-1.38-.11l-53.81-31.29a6.47,6.47,0,0,1-3.15-4.6l-5.53-35.18A1.59,1.59,0,0,1,195.65,255.65Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225,287.84a11.85,11.85,0,0,1,5.34,7.69c.35,2.74-1.46,3.76-4.07,2.26a11.91,11.91,0,0,1-5.34-7.69C220.58,287.35,222.4,286.34,225,287.84Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.76,326.71l-5.53-35.18a6.5,6.5,0,0,0-3.15-4.6l-53.81-31.29a1.59,1.59,0,0,0-1.62,0h0l1.28-.64h0a1.58,1.58,0,0,1,1.43.09l53.81,31.29a6.47,6.47,0,0,1,3.15,4.6l5.53,35.18a1.59,1.59,0,0,1-.9,1.7h0l-1.24.61h0A1.61,1.61,0,0,0,259.76,326.71Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.21,204.7l-4.71.49a11.57,11.57,0,0,0-8.47,5.12c-4.9,7.48-7.19,19-5.88,31.44,1,9.47,1.71,18.88-3.82,32.95-2,5,1.07,10.7,6.07,12.69,15.85,6.31,38.49,3.5,50.21-.34a7.08,7.08,0,0,0,4.3-9.56s-4.4-24.24-3.55-26.2c1.93-4.5,2.39-15.37,2.86-22.22a35.79,35.79,0,0,0-3.74-17.63l-18-6.74Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.38,196.13a8.64,8.64,0,0,0,3.66,2.93,4.58,4.58,0,0,0,6.44-4.87,7.11,7.11,0,0,0,4.88-4.42,8.08,8.08,0,0,0-.62-6.87c2.76-1.6,5.41-3.85,6.5-7s-.22-7.25-3.13-8.5a6.21,6.21,0,0,0,1.11-7.14,5.24,5.24,0,0,0-6.21-2.67,8.53,8.53,0,0,0-4.94-6.82A7.82,7.82,0,0,0,315,152a4.49,4.49,0,0,0-3.39-2.32,4.29,4.29,0,0,0-3.72,1.62,6.21,6.21,0,0,0-6.94-1.73,11.51,11.51,0,0,0-5.64,5.41,4.75,4.75,0,0,0-4.85.26,5.65,5.65,0,0,0-2.39,4.57,5.83,5.83,0,0,0,2.3,4.7,4.13,4.13,0,0,0-2.46,3.19,4.36,4.36,0,0,0,1.37,3.89,3.62,3.62,0,0,0,3.8.59c4.12,4.46,11.37,4.42,15.93,8.35a16,16,0,0,1,4.36,6.86C314.26,190,313.72,194,315.38,196.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.6,192.8v12.25a5.79,5.79,0,0,1-2,4.35,16.44,16.44,0,0,1-11.71,4,4.15,4.15,0,0,1-2.44-.75,3.21,3.21,0,0,1-.78-3.33,6.43,6.43,0,0,1,.89-1.8,5.58,5.58,0,0,0,1-3.11V192.8Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.67,202.7a33.15,33.15,0,0,1-6.09,1.2V192.8h15v2.61a12.07,12.07,0,0,1-1.23,2.15A15,15,0,0,1,313.67,202.7Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331,178.69a4.85,4.85,0,0,0-3.86,1.13A14.75,14.75,0,0,0,324.4,183a4.7,4.7,0,0,1-1.34,1.43,1.62,1.62,0,0,1-1.85,0,2.42,2.42,0,0,1-.53-2l.24-5.12a2.06,2.06,0,0,0-1.14-1.9,5,5,0,0,1-2.29-2.63c-.07-.18-.12-.35-.18-.53a4.28,4.28,0,0,1-3.09.48,4.37,4.37,0,0,1-2.7-1.91,3.13,3.13,0,0,1-2.37,1.55,3,3,0,0,1-2.52-1.16,5.38,5.38,0,0,1-8.84-.08,5.65,5.65,0,0,1-5.27-.52,63,63,0,0,0,1.68,23.52,19.36,19.36,0,0,0,1.94,5,8.16,8.16,0,0,0,4,3.52c2.07.77,4.38.4,6.56,0,4-.71,8.07-1.45,11.54-3.54s6.2-5.88,5.87-9.92a6.94,6.94,0,0,0,6.62.37,7,7,0,0,0,3.63-5.61C334.47,181.66,333.17,179.14,331,178.69Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "303.87 182.03 299.27 189.77 304.75 190.8 303.87 182.03",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310,193.47l-4.17,2a2.73,2.73,0,0,0,3.16.9A2.45,2.45,0,0,0,310,193.47Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310,193.47l-4.17,2a2.73,2.73,0,0,0,3.16.9A2.45,2.45,0,0,0,310,193.47Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.58,196.53a2.45,2.45,0,0,0,1.45-.14,2.21,2.21,0,0,0,1.12-2.19,2.58,2.58,0,0,0-1.65.57A2.65,2.65,0,0,0,307.58,196.53Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.81,182.34a1.57,1.57,0,1,1-1.73-1.41A1.56,1.56,0,0,1,311.81,182.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.6,183.16a1.57,1.57,0,1,1-1.72-1.41A1.57,1.57,0,0,1,298.6,183.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.45,177.07l-3.23,2.76a2.25,2.25,0,0,1,.43-2.53A2.68,2.68,0,0,1,296.45,177.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.85,175.53l3.71,2.06a2.23,2.23,0,0,0-.92-2.39A2.66,2.66,0,0,0,309.85,175.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349,288.15c-5.25,5.15-20.2,11.93-30.37,8.26-2.36-30.81-.2-79.47,3.91-91.71l18,6.69c10.68,18.24,3.59,48.1,3.59,48.1A106.3,106.3,0,0,0,349,288.15Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349,288.15c-5.25,5.15-20.2,11.93-30.37,8.26-2.36-30.81-.2-79.47,3.91-91.71l18,6.69c10.68,18.24,3.59,48.1,3.59,48.1A106.3,106.3,0,0,0,349,288.15Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.65,232.21l-6.42-7.46,5.18-3.59a3,3,0,0,0,.92-3.89l-6.81-12.57c-2.64,7.86-4.47,30.74-4.82,54.26L330,235.56A3,3,0,0,0,329.65,232.21Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.65,232.21l-6.42-7.46,5.18-3.59a3,3,0,0,0,.92-3.89l-6.81-12.57c-2.64,7.86-4.47,30.74-4.82,54.26L330,235.56A3,3,0,0,0,329.65,232.21Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.58,204.7c-3.05,3.76-13.23,15.75-14.58,59.92-.35,11.51-5.81,25.36-5.81,25.36l-7.63-10.9s8.67-10.67,8.67-28.31-3.25-23.85,2-35,11.19-10.79,12.94-11l4.41-.55Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.58,204.7c-3.05,3.76-13.23,15.75-14.58,59.92-.35,11.51-5.81,25.36-5.81,25.36l-7.63-10.9s8.67-10.67,8.67-28.31-3.25-23.85,2-35,11.19-10.79,12.94-11l4.41-.55Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.58,204.18l-13,10.86a3,3,0,0,0-.76,3.65l1.46,2.91-4.78,5.12a5,5,0,0,0-1.26,4.31l4.28,23.48c2.46-35.93,11.27-46.35,14.08-49.81Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.58,204.18l-13,10.86a3,3,0,0,0-.76,3.65l1.46,2.91-4.78,5.12a5,5,0,0,0-1.26,4.31l4.28,23.48c2.46-35.93,11.27-46.35,14.08-49.81Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.55,211.39l-18.94,56.92-33.77,13.12a11.61,11.61,0,0,1-5.43.84l-9.08-1.58a6.11,6.11,0,0,0-3.66.86l-6.26,3.79a7,7,0,0,0-1.67,1.43l-3.06,3.63a2.29,2.29,0,0,0,.42,3.35l1.92,1.38a6.89,6.89,0,0,0,7.08.55l4.84-2.44,2.23.53a22.62,22.62,0,0,0,14.55-1.39h0l36.63-7.4a16.25,16.25,0,0,0,11.89-10.25s17.51-41.54,13.37-50.93C349.82,219.73,340.55,211.39,340.55,211.39Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.55,211.39,321,267.66l-33.77,12.92c6.29,3.51,6.62,11.38,6,12.31l35.74-7.48a13.91,13.91,0,0,0,10.16-8.7l14.35-38c6.21-17.06-2.81-23.33-12.86-27.27Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.55,211.39,321,267.66l-33.77,12.92c6.29,3.51,6.62,11.38,6,12.31l35.74-7.48a13.91,13.91,0,0,0,10.16-8.7l14.35-38c6.21-17.06-2.81-23.33-12.86-27.27Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.07,283.39a13.4,13.4,0,0,0-4.71-6.32l-9.17,3.51c6.29,3.51,6.62,11.38,6,12.31l8.21-1.72A13.48,13.48,0,0,0,301.07,283.39Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321,267.66c6.21.08,10.54,2.78,11.2,4.74-1.06-9.32-10.19-7.66-10.19-7.66Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.5,322.6l-9.91-.6-9.91.6L260.14,340h0a4.08,4.08,0,0,0,2.27,2.89,11.5,11.5,0,0,0,10.38,0A4,4,0,0,0,275,340h0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.08,318.73H276.8a8,8,0,0,0-1.82-1.41,16.33,16.33,0,0,0-14.82,0,8,8,0,0,0-1.81,1.41h-1.24v2.88h0c0,1.56,1,3.11,3.09,4.3a16.35,16.35,0,0,0,14.83,0c2-1.19,3.06-2.74,3.05-4.3h0Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275,314.44a16.33,16.33,0,0,0-14.82,0c-4.09,2.37-4.06,6.22,0,8.59A16.35,16.35,0,0,0,275,323C279.11,320.66,279.09,316.81,275,314.44Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275,314.44a16.33,16.33,0,0,0-14.82,0c-4.09,2.37-4.06,6.22,0,8.59A16.35,16.35,0,0,0,275,323C279.11,320.66,279.09,316.81,275,314.44Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.38,317.62h0l-.73-2.54h-1.21c-.19-.13-.39-.26-.6-.38a13.86,13.86,0,0,0-12.57,0,6.86,6.86,0,0,0-.6.38h-1.17l-.65,2.25a.24.24,0,0,0,0,.08l-.07.21h0c-.36,1.54.48,3.16,2.54,4.35a13.86,13.86,0,0,0,12.57,0C275.94,320.78,276.76,319.16,276.38,317.62Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.35,312.43a12.77,12.77,0,0,0-11.55,0c-3.17,1.85-3.16,4.84,0,6.69a12.69,12.69,0,0,0,11.54,0C276.56,317.27,276.54,314.28,273.35,312.43Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.35,312.43a12.77,12.77,0,0,0-11.55,0c-3.17,1.85-3.16,4.84,0,6.69a12.69,12.69,0,0,0,11.54,0C276.56,317.27,276.54,314.28,273.35,312.43Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.43,314.23a11.46,11.46,0,0,1,10.29,0,3.36,3.36,0,0,1,1.73,1.91,1.34,1.34,0,0,0,.05-.35,3,3,0,0,0-1.78-2.27,11.46,11.46,0,0,0-10.29,0c-1.11.65-1.74,1.46-1.74,2.24a2.2,2.2,0,0,0,0,.36A3.31,3.31,0,0,1,262.43,314.23Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.43,314.23a11.46,11.46,0,0,1,10.29,0,3.36,3.36,0,0,1,1.73,1.91,1.34,1.34,0,0,0,.05-.35,3,3,0,0,0-1.78-2.27,11.46,11.46,0,0,0-10.29,0c-1.11.65-1.74,1.46-1.74,2.24a2.2,2.2,0,0,0,0,.36A3.31,3.31,0,0,1,262.43,314.23Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.47,318a10.65,10.65,0,0,0,5.15,1.22h0a10.46,10.46,0,0,0,5.13-1.22,3.27,3.27,0,0,0,1.7-1.89,3.36,3.36,0,0,0-1.73-1.91,11.46,11.46,0,0,0-10.29,0,3.31,3.31,0,0,0-1.7,1.89A3.38,3.38,0,0,0,262.47,318Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.47,318a10.65,10.65,0,0,0,5.15,1.22h0a10.46,10.46,0,0,0,5.13-1.22,3.27,3.27,0,0,0,1.7-1.89,3.36,3.36,0,0,0-1.73-1.91,11.46,11.46,0,0,0-10.29,0,3.31,3.31,0,0,0-1.7,1.89A3.38,3.38,0,0,0,262.47,318Z",
    style: {
      opacity: 0.2
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginCover);
export default __webpack_public_path__ + "static/media/login-cover.e687bd43e24a710c71a8b0d0a249437c.svg";
export { ForwardRef as ReactComponent };